import { type CRRFlashQuestion } from './crr-flash-questions';

export type FluvialFlashQuestion = Omit<CRRFlashQuestion, 'category'> & {
  category: 'signalisation' | 'ecluses' | 'reglementation' | 'navigation' | 'securite';
};

export const fluvialFlashQuestions: FluvialFlashQuestion[] = [
  {
    id: "flu-panneau-interdit",
    question_fr: "Que signifie un panneau carré rouge barré en diagonale ?",
    question_en: "What does a red square panel with diagonal bar mean?",
    answer_fr: "Interdiction de passage",
    answer_en: "Passage prohibited",
    context_fr: "Rouge = interdiction sur les voies intérieures.",
    context_en: "Red = prohibition on inland waterways.",
    category: "signalisation"
  },
  {
    id: "flu-panneau-bleu",
    question_fr: "Que signifie un panneau bleu carré ?",
    question_en: "What does a square blue panel mean?",
    answer_fr: "Obligation ou recommandation",
    answer_en: "Obligation or recommendation",
    context_fr: "Bleu = obligation (comme le code de la route).",
    context_en: "Blue = obligation (like road signs).",
    category: "signalisation"
  },
  {
    id: "flu-panneau-jaune",
    question_fr: "Panneau carré jaune avec liseré noir ?",
    question_en: "Yellow square panel with black border?",
    answer_fr: "Recommandation / indication",
    answer_en: "Recommendation / information",
    context_fr: "Donne une information utile, sans obligation.",
    context_en: "Provides useful information, no obligation.",
    category: "signalisation"
  },
  {
    id: "flu-a1",
    question_fr: "Panneau A.1 (rond rouge bordé blanc, barre blanche) ?",
    question_en: "Sign A.1?",
    answer_fr: "Interdiction générale de passage",
    answer_en: "General no entry",
    context_fr: "Aucun bateau ne peut franchir.",
    context_en: "No vessel may pass.",
    category: "signalisation"
  },
  {
    id: "flu-a2",
    question_fr: "Panneau A.2 ?",
    question_en: "Sign A.2?",
    answer_fr: "Interdiction de dépasser",
    answer_en: "No overtaking",
    context_fr: "S'applique à tous les bateaux.",
    context_en: "Applies to all vessels.",
    category: "signalisation"
  },
  {
    id: "flu-a3",
    question_fr: "Panneau A.3 ?",
    question_en: "Sign A.3?",
    answer_fr: "Interdiction de dépasser entre convois",
    answer_en: "No overtaking between convoys",
    context_fr: "Convois poussés ou remorqués.",
    context_en: "Pushed or towed convoys.",
    category: "signalisation"
  },
  {
    id: "flu-a4",
    question_fr: "Panneau A.4 ?",
    question_en: "Sign A.4?",
    answer_fr: "Interdiction de croiser et dépasser",
    answer_en: "No passing or overtaking",
    context_fr: "Chenal étroit.",
    context_en: "Narrow channel.",
    category: "signalisation"
  },
  {
    id: "flu-a5",
    question_fr: "Panneau A.5 ?",
    question_en: "Sign A.5?",
    answer_fr: "Interdiction de stationner",
    answer_en: "No berthing",
    context_fr: "Sur le côté indiqué.",
    context_en: "On the indicated side.",
    category: "signalisation"
  },
  {
    id: "flu-a6",
    question_fr: "Panneau A.6 ?",
    question_en: "Sign A.6?",
    answer_fr: "Interdiction d'ancrer",
    answer_en: "No anchoring",
    context_fr: "Risque câbles sous-marins.",
    context_en: "Risk of underwater cables.",
    category: "signalisation"
  },
  {
    id: "flu-a7",
    question_fr: "Panneau A.7 ?",
    question_en: "Sign A.7?",
    answer_fr: "Interdiction d'amarrer à la rive",
    answer_en: "No mooring to bank",
    context_fr: "Pas d'amarres à terre.",
    context_en: "No lines to shore.",
    category: "signalisation"
  },
  {
    id: "flu-a8",
    question_fr: "Panneau A.8 ?",
    question_en: "Sign A.8?",
    answer_fr: "Interdiction de virer",
    answer_en: "No turning",
    context_fr: "Manœuvre interdite à cet endroit.",
    context_en: "No turning here.",
    category: "signalisation"
  },
  {
    id: "flu-a9",
    question_fr: "Panneau A.9 ?",
    question_en: "Sign A.9?",
    answer_fr: "Éviter de produire des remous",
    answer_en: "Avoid making waves/wash",
    context_fr: "Réduire la vitesse.",
    context_en: "Reduce speed.",
    category: "signalisation"
  },
  {
    id: "flu-a10",
    question_fr: "Panneau A.10 ?",
    question_en: "Sign A.10?",
    answer_fr: "Interdit de passer hors de l'espace indiqué",
    answer_en: "Prohibited to pass outside indicated area",
    context_fr: "Limites de chenal.",
    context_en: "Channel limits.",
    category: "signalisation"
  },
  {
    id: "flu-a12",
    question_fr: "Panneau A.12 ?",
    question_en: "Sign A.12?",
    answer_fr: "Interdiction aux bateaux à moteur",
    answer_en: "No motor vessels",
    context_fr: "Réservé non-motorisés.",
    context_en: "Reserved for non-motorized.",
    category: "signalisation"
  },
  {
    id: "flu-a13",
    question_fr: "Panneau A.13 ?",
    question_en: "Sign A.13?",
    answer_fr: "Interdiction aux bateaux de sport / plaisance",
    answer_en: "No sport/pleasure craft",
    context_fr: "Zone professionnelle.",
    context_en: "Professional zone only.",
    category: "signalisation"
  },
  {
    id: "flu-a14",
    question_fr: "Panneau A.14 ?",
    question_en: "Sign A.14?",
    answer_fr: "Interdiction de pratiquer le ski nautique",
    answer_en: "No water-skiing",
    context_fr: "Ski interdit ici.",
    context_en: "Water-ski prohibited.",
    category: "signalisation"
  },
  {
    id: "flu-a15",
    question_fr: "Panneau A.15 ?",
    question_en: "Sign A.15?",
    answer_fr: "Interdiction aux voiliers",
    answer_en: "No sailing",
    context_fr: "Section interdite à la voile.",
    context_en: "Sailing prohibited.",
    category: "signalisation"
  },
  {
    id: "flu-a16",
    question_fr: "Panneau A.16 ?",
    question_en: "Sign A.16?",
    answer_fr: "Interdiction aux engins de plage / planches à voile",
    answer_en: "No windsurfing / beach craft",
    context_fr: "Restriction loisirs.",
    context_en: "Leisure restriction.",
    category: "signalisation"
  },
  {
    id: "flu-a17",
    question_fr: "Panneau A.17 ?",
    question_en: "Sign A.17?",
    answer_fr: "Interdiction à la baignade",
    answer_en: "No swimming",
    context_fr: "Baignade dangereuse.",
    context_en: "Swimming dangerous.",
    category: "signalisation"
  },
  {
    id: "flu-a18",
    question_fr: "Panneau A.18 ?",
    question_en: "Sign A.18?",
    answer_fr: "Fin d'une voie navigable pour navires",
    answer_en: "End of waterway for ships",
    context_fr: "Limite de navigation.",
    context_en: "End of navigable section.",
    category: "signalisation"
  },
  {
    id: "flu-a19",
    question_fr: "Panneau A.19 ?",
    question_en: "Sign A.19?",
    answer_fr: "Ne pas produire de vagues / éviter remous",
    answer_en: "Don't produce waves",
    context_fr: "Berges sensibles.",
    context_en: "Sensitive banks.",
    category: "signalisation"
  },
  {
    id: "flu-a20",
    question_fr: "Panneau A.20 ?",
    question_en: "Sign A.20?",
    answer_fr: "Interdit aux véhicules nautiques à moteur (jet)",
    answer_en: "No personal watercraft",
    context_fr: "Jet-ski interdit.",
    context_en: "No jet-ski.",
    category: "signalisation"
  },
  {
    id: "flu-b1",
    question_fr: "Panneau B.1 ?",
    question_en: "Sign B.1?",
    answer_fr: "Obligation de prendre la direction indiquée",
    answer_en: "Obligation to take indicated direction",
    context_fr: "Suivre la flèche.",
    context_en: "Follow arrow.",
    category: "signalisation"
  },
  {
    id: "flu-b2",
    question_fr: "Panneau B.2a/b ?",
    question_en: "Sign B.2?",
    answer_fr: "Obligation de tenir le côté indiqué du chenal",
    answer_en: "Keep to indicated side of channel",
    context_fr: "Bâbord ou tribord.",
    context_en: "Port or starboard side.",
    category: "signalisation"
  },
  {
    id: "flu-b3",
    question_fr: "Panneau B.3 ?",
    question_en: "Sign B.3?",
    answer_fr: "Obligation de passer du côté indiqué",
    answer_en: "Pass on indicated side",
    context_fr: "Croisement obligatoire.",
    context_en: "Mandatory passing side.",
    category: "signalisation"
  },
  {
    id: "flu-b4",
    question_fr: "Panneau B.4 ?",
    question_en: "Sign B.4?",
    answer_fr: "Obligation de traverser le chenal",
    answer_en: "Obligation to cross channel",
    context_fr: "Vers la rive indiquée.",
    context_en: "Toward indicated bank.",
    category: "signalisation"
  },
  {
    id: "flu-b5",
    question_fr: "Panneau B.5 ?",
    question_en: "Sign B.5?",
    answer_fr: "Obligation de s'arrêter dans certaines conditions",
    answer_en: "Stop in certain conditions",
    context_fr: "Avant écluse / douane.",
    context_en: "Before lock / customs.",
    category: "signalisation"
  },
  {
    id: "flu-b6",
    question_fr: "Panneau B.6 ?",
    question_en: "Sign B.6?",
    answer_fr: "Obligation de ne pas dépasser la vitesse indiquée (km/h)",
    answer_en: "Speed limit (km/h)",
    context_fr: "Vitesse max sur l'eau.",
    context_en: "Max speed on water.",
    category: "signalisation"
  },
  {
    id: "flu-b7",
    question_fr: "Panneau B.7 ?",
    question_en: "Sign B.7?",
    answer_fr: "Obligation d'émettre un signal sonore",
    answer_en: "Sound a horn",
    context_fr: "Avant courbe sans visibilité.",
    context_en: "Before blind bend.",
    category: "signalisation"
  },
  {
    id: "flu-b8",
    question_fr: "Panneau B.8 ?",
    question_en: "Sign B.8?",
    answer_fr: "Obligation de redoubler de vigilance",
    answer_en: "Increased vigilance",
    context_fr: "Zone à risque.",
    context_en: "High-risk zone.",
    category: "signalisation"
  },
  {
    id: "flu-b9",
    question_fr: "Panneau B.9a/b ?",
    question_en: "Sign B.9?",
    answer_fr: "Obligation de céder le passage à la navigation principale",
    answer_en: "Give way to main waterway",
    context_fr: "Sortie de port / affluent.",
    context_en: "Harbor exit / tributary.",
    category: "signalisation"
  },
  {
    id: "flu-b11",
    question_fr: "Panneau B.11 ?",
    question_en: "Sign B.11?",
    answer_fr: "Obligation d'utiliser la VHF",
    answer_en: "Use VHF radio",
    context_fr: "Canal indiqué.",
    context_en: "Indicated channel.",
    category: "signalisation"
  },
  {
    id: "flu-e1",
    question_fr: "Panneau E.1 ?",
    question_en: "Sign E.1?",
    answer_fr: "Autorisation de passer",
    answer_en: "Passage permitted",
    context_fr: "Inverse de A.1.",
    context_en: "Opposite of A.1.",
    category: "signalisation"
  },
  {
    id: "flu-e2",
    question_fr: "Panneau E.2 ?",
    question_en: "Sign E.2?",
    answer_fr: "Câble électrique aérien",
    answer_en: "Overhead power cable",
    context_fr: "Attention hauteur libre.",
    context_en: "Mind air draft.",
    category: "signalisation"
  },
  {
    id: "flu-e3",
    question_fr: "Panneau E.3 ?",
    question_en: "Sign E.3?",
    answer_fr: "Barrage",
    answer_en: "Weir / dam",
    context_fr: "Danger en aval.",
    context_en: "Danger downstream.",
    category: "signalisation"
  },
  {
    id: "flu-e4",
    question_fr: "Panneau E.4 ?",
    question_en: "Sign E.4?",
    answer_fr: "Bac ne naviguant pas librement",
    answer_en: "Non-free-running ferry",
    context_fr: "Bac à câble.",
    context_en: "Cable ferry.",
    category: "signalisation"
  },
  {
    id: "flu-e5",
    question_fr: "Panneau E.5 ?",
    question_en: "Sign E.5?",
    answer_fr: "Bac naviguant librement",
    answer_en: "Free-running ferry",
    context_fr: "Bac autonome.",
    context_en: "Free ferry.",
    category: "signalisation"
  },
  {
    id: "flu-e6",
    question_fr: "Panneau E.6 ?",
    question_en: "Sign E.6?",
    answer_fr: "Autorisation d'ancrer",
    answer_en: "Anchoring permitted",
    context_fr: "Mouillage autorisé.",
    context_en: "Anchoring allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e7",
    question_fr: "Panneau E.7 ?",
    question_en: "Sign E.7?",
    answer_fr: "Autorisation d'amarrer",
    answer_en: "Mooring permitted",
    context_fr: "Amarrage autorisé.",
    context_en: "Mooring allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e8",
    question_fr: "Panneau E.8 ?",
    question_en: "Sign E.8?",
    answer_fr: "Aire de virage",
    answer_en: "Turning area",
    context_fr: "Demi-tour autorisé.",
    context_en: "Turning allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e9",
    question_fr: "Panneau E.9 ?",
    question_en: "Sign E.9?",
    answer_fr: "Voie navigable considérée comme principale",
    answer_en: "Main waterway",
    context_fr: "Voie prioritaire.",
    context_en: "Priority waterway.",
    category: "signalisation"
  },
  {
    id: "flu-e10",
    question_fr: "Panneau E.10 ?",
    question_en: "Sign E.10?",
    answer_fr: "Voie navigable débouchant sur la principale",
    answer_en: "Tributary entering main waterway",
    context_fr: "Affluent.",
    context_en: "Tributary.",
    category: "signalisation"
  },
  {
    id: "flu-e11",
    question_fr: "Panneau E.11 ?",
    question_en: "Sign E.11?",
    answer_fr: "Fin d'une interdiction ou obligation",
    answer_en: "End of restriction",
    context_fr: "Levée de la règle.",
    context_en: "Restriction ends.",
    category: "signalisation"
  },
  {
    id: "flu-e13",
    question_fr: "Panneau E.13 ?",
    question_en: "Sign E.13?",
    answer_fr: "Poste d'eau potable",
    answer_en: "Drinking water",
    context_fr: "Avitaillement.",
    context_en: "Water supply.",
    category: "signalisation"
  },
  {
    id: "flu-e14",
    question_fr: "Panneau E.14 ?",
    question_en: "Sign E.14?",
    answer_fr: "Téléphone",
    answer_en: "Telephone",
    context_fr: "Cabine / poste.",
    context_en: "Phone available.",
    category: "signalisation"
  },
  {
    id: "flu-e15",
    question_fr: "Panneau E.15 ?",
    question_en: "Sign E.15?",
    answer_fr: "Autorisation aux bateaux à moteur",
    answer_en: "Motor vessels permitted",
    context_fr: "Moteur autorisé.",
    context_en: "Motor allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e16",
    question_fr: "Panneau E.16 ?",
    question_en: "Sign E.16?",
    answer_fr: "Autorisation aux engins de plaisance",
    answer_en: "Pleasure craft permitted",
    context_fr: "Loisirs autorisés.",
    context_en: "Leisure craft allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e17",
    question_fr: "Panneau E.17 ?",
    question_en: "Sign E.17?",
    answer_fr: "Autorisation au ski nautique",
    answer_en: "Water-skiing permitted",
    context_fr: "Ski autorisé.",
    context_en: "Water-ski allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e18",
    question_fr: "Panneau E.18 ?",
    question_en: "Sign E.18?",
    answer_fr: "Autorisation aux voiliers",
    answer_en: "Sailing permitted",
    context_fr: "Voile autorisée.",
    context_en: "Sailing allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e19",
    question_fr: "Panneau E.19 ?",
    question_en: "Sign E.19?",
    answer_fr: "Autorisation aux planches à voile",
    answer_en: "Windsurfing permitted",
    context_fr: "Planche autorisée.",
    context_en: "Windsurf allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e20",
    question_fr: "Panneau E.20 ?",
    question_en: "Sign E.20?",
    answer_fr: "Autorisation aux véhicules nautiques à moteur",
    answer_en: "Jet-ski permitted",
    context_fr: "Jet-ski autorisé.",
    context_en: "Jet-ski allowed.",
    category: "signalisation"
  },
  {
    id: "flu-e21",
    question_fr: "Panneau E.21 ?",
    question_en: "Sign E.21?",
    answer_fr: "Baignade autorisée",
    answer_en: "Swimming permitted",
    context_fr: "Zone de baignade.",
    context_en: "Swim zone.",
    category: "signalisation"
  },
  {
    id: "flu-feu-rouge-fixe",
    question_fr: "2 feux rouges fixes superposés à l'écluse ?",
    question_en: "2 fixed red lights at lock?",
    answer_fr: "Écluse hors service / fermée",
    answer_en: "Lock out of service / closed",
    context_fr: "Ne pas s'engager.",
    context_en: "Do not enter.",
    category: "signalisation"
  },
  {
    id: "flu-feu-rouge-clignotant",
    question_fr: "Feu rouge clignotant ?",
    question_en: "Flashing red light?",
    answer_fr: "Interdiction de passer — danger",
    answer_en: "No passage — danger",
    context_fr: "Stop immédiat.",
    context_en: "Stop immediately.",
    category: "signalisation"
  },
  {
    id: "flu-feu-vert-fixe",
    question_fr: "Feu vert fixe à l'écluse ?",
    question_en: "Fixed green light at lock?",
    answer_fr: "Autorisation d'entrer",
    answer_en: "Permission to enter",
    context_fr: "Voie libre.",
    context_en: "Clear to enter.",
    category: "signalisation"
  },
  {
    id: "flu-feu-rouge-vert",
    question_fr: "Feu rouge + vert simultanés ?",
    question_en: "Red + green at the same time?",
    answer_fr: "Préparez-vous à passer",
    answer_en: "Get ready to enter",
    context_fr: "L'écluse va ouvrir.",
    context_en: "Lock about to open.",
    category: "signalisation"
  },
  {
    id: "flu-feu-jaune-cligno",
    question_fr: "Feu jaune clignotant sur pont ?",
    question_en: "Flashing yellow on bridge?",
    answer_fr: "Passage avec précaution",
    answer_en: "Pass with caution",
    context_fr: "Hauteur réduite.",
    context_en: "Reduced clearance.",
    category: "signalisation"
  },
  {
    id: "flu-balisage-rouge",
    question_fr: "Bouée latérale rouge en rivière ?",
    question_en: "Red lateral buoy on river?",
    answer_fr: "À laisser à bâbord en avalant",
    answer_en: "Keep to port when descending",
    context_fr: "Convention fluviale française.",
    context_en: "French river convention.",
    category: "signalisation"
  },
  {
    id: "flu-balisage-vert",
    question_fr: "Bouée latérale verte en rivière ?",
    question_en: "Green lateral buoy on river?",
    answer_fr: "À laisser à tribord en avalant",
    answer_en: "Keep to starboard when descending",
    context_fr: "Sens de la descente.",
    context_en: "Downstream direction.",
    category: "signalisation"
  },
  {
    id: "flu-kilometrage",
    question_fr: "Que sont les bornes kilométriques (PK) ?",
    question_en: "What are kilometer markers (PK)?",
    answer_fr: "Points kilométriques le long de la voie d'eau",
    answer_en: "Kilometer points along waterway",
    context_fr: "Repérage et navigation.",
    context_en: "Position reference.",
    category: "signalisation"
  },
  {
    id: "flu-panneau-hauteur",
    question_fr: "Panneau triangulaire avec hauteur en mètres ?",
    question_en: "Triangular sign with height in meters?",
    answer_fr: "Hauteur libre sous un pont",
    answer_en: "Air draft under bridge",
    context_fr: "Vérifier tirant d'air.",
    context_en: "Check air draft.",
    category: "signalisation"
  },
  {
    id: "flu-panneau-profondeur",
    question_fr: "Panneau triangulaire pointe en bas avec chiffre ?",
    question_en: "Triangle pointing down with number?",
    answer_fr: "Profondeur d'eau disponible",
    answer_en: "Available water depth",
    context_fr: "Comparer au tirant d'eau.",
    context_en: "Compare to draft.",
    category: "signalisation"
  },
  {
    id: "flu-panneau-largeur",
    question_fr: "Panneau losange avec largeur ?",
    question_en: "Diamond sign with width?",
    answer_fr: "Largeur libre du chenal ou de la passe",
    answer_en: "Available channel width",
    context_fr: "Passage étroit.",
    context_en: "Narrow passage.",
    category: "signalisation"
  },
  {
    id: "flu-ecl-def",
    question_fr: "À quoi sert une écluse ?",
    question_en: "Purpose of a lock?",
    answer_fr: "Franchir une différence de niveau entre 2 biefs",
    answer_en: "Cross water-level difference between reaches",
    context_fr: "Sas qui se remplit/se vide.",
    context_en: "Chamber fills/empties.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-priorite",
    question_fr: "Qui a la priorité dans une écluse ?",
    question_en: "Who has priority in a lock?",
    answer_fr: "L'avalant (descendant), sauf signalisation contraire",
    answer_en: "Downstream boat unless signs say otherwise",
    context_fr: "Plus difficile à arrêter.",
    context_en: "Harder to stop.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-amarrage",
    question_fr: "Comment s'amarrer dans le sas ?",
    question_en: "How to moor in the chamber?",
    answer_fr: "Amarres tenues à la main, jamais frappées",
    answer_en: "Hold lines by hand, never tied fast",
    context_fr: "Niveau d'eau change.",
    context_en: "Water level changes.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-entree",
    question_fr: "Quand entrer dans le sas ?",
    question_en: "When to enter the chamber?",
    answer_fr: "Sur feu vert uniquement",
    answer_en: "Only on green light",
    context_fr: "Respecter signalisation.",
    context_en: "Follow signals.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-attente",
    question_fr: "Où attendre avant l'écluse ?",
    question_en: "Where to wait before the lock?",
    answer_fr: "À la gare d'attente prévue",
    answer_en: "At the waiting basin",
    context_fr: "Hors du chenal.",
    context_en: "Out of channel.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-moteur",
    question_fr: "Le moteur dans le sas ?",
    question_en: "Engine in the chamber?",
    answer_fr: "Au point mort, prêt à manœuvrer",
    answer_en: "Idle, ready to manoeuvre",
    context_fr: "Pas de marche AV inutile.",
    context_en: "No needless forward.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-ordre-amont",
    question_fr: "Ordre d'amarrage en avalant ?",
    question_en: "Mooring order going downstream?",
    answer_fr: "Avant puis arrière",
    answer_en: "Bow then stern",
    context_fr: "Maîtriser le bateau.",
    context_en: "Control the boat.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-ordre-aval",
    question_fr: "Ordre en montant ?",
    question_en: "Mooring order going upstream?",
    answer_fr: "Avant puis arrière, attention aux remous",
    answer_en: "Bow then stern, watch turbulence",
    context_fr: "Eau qui monte = courants.",
    context_en: "Rising water = currents.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-eclusage",
    question_fr: "Que signifie « éclusage » ?",
    question_en: "What does 'lockage' mean?",
    answer_fr: "L'opération de passage d'une écluse",
    answer_en: "The act of passing through a lock",
    context_fr: "Cycle complet.",
    context_en: "Full cycle.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-manuelle",
    question_fr: "Écluse manuelle = ?",
    question_en: "Manual lock = ?",
    answer_fr: "À actionner soi-même (manivelle / vantelles)",
    answer_en: "Operate yourself (winches / paddles)",
    context_fr: "Petits canaux.",
    context_en: "Small canals.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-automatique",
    question_fr: "Écluse automatique ?",
    question_en: "Automatic lock?",
    answer_fr: "Déclenchée par capteur ou perche",
    answer_en: "Triggered by sensor / pole",
    context_fr: "VNF.",
    context_en: "French waterways.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-vhf",
    question_fr: "Canal VHF d'écluse fréquent ?",
    question_en: "Common lock VHF channel?",
    answer_fr: "Canal 10 (ou 20/22 selon zone)",
    answer_en: "Channel 10 (or 20/22)",
    context_fr: "Annoncer son arrivée.",
    context_en: "Announce arrival.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-horaires",
    question_fr: "Horaires d'écluse VNF ?",
    question_en: "VNF lock opening hours?",
    answer_fr: "Souvent 9h–19h, variable selon saison",
    answer_en: "Often 9am–7pm, seasonal",
    context_fr: "Hors créneau = pas d'éclusage.",
    context_en: "Outside = no lockage.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-dimensions",
    question_fr: "Gabarit Freycinet ?",
    question_en: "Freycinet gauge?",
    answer_fr: "Sas 38,5 m x 5,05 m, 1,80 m de tirant d'eau",
    answer_en: "Chamber 38.5 x 5.05 m, 1.80 m draft",
    context_fr: "Standard français.",
    context_en: "French standard.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-vantelles",
    question_fr: "Que sont les vantelles ?",
    question_en: "What are paddles/vannes?",
    answer_fr: "Les petites portes qui laissent passer l'eau",
    answer_en: "Small gates letting water through",
    context_fr: "Remplissent le sas.",
    context_en: "Fill the chamber.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-bajoyer",
    question_fr: "Bajoyer = ?",
    question_en: "Lock side wall?",
    answer_fr: "Mur latéral du sas",
    answer_en: "Side wall of chamber",
    context_fr: "Échelles & bollards.",
    context_en: "Ladders & bollards.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-bollard",
    question_fr: "Rôle des bollards flottants ?",
    question_en: "Floating bollards?",
    answer_fr: "Suivent le niveau d'eau pendant l'éclusage",
    answer_en: "Move with water level during lockage",
    context_fr: "Amarrage facile.",
    context_en: "Easy mooring.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-echelle",
    question_fr: "Échelle d'écluse ?",
    question_en: "Lock ladder?",
    answer_fr: "Permet de sortir en cas de chute",
    answer_en: "To climb out if you fall",
    context_fr: "Sécurité.",
    context_en: "Safety.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-vitesse-sas",
    question_fr: "Vitesse dans le sas ?",
    question_en: "Speed in the chamber?",
    answer_fr: "Au minimum / au pas",
    answer_en: "Walking pace / minimum",
    context_fr: "Pas de remous.",
    context_en: "No wash.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-vidange",
    question_fr: "Sens de vidange du sas ?",
    question_en: "Direction of draining?",
    answer_fr: "Vers l'aval (bief inférieur)",
    answer_en: "Toward downstream (lower reach)",
    context_fr: "Gravité.",
    context_en: "Gravity.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-remplissage",
    question_fr: "Remplissage du sas ?",
    question_en: "Filling the chamber?",
    answer_fr: "Depuis l'amont (bief supérieur)",
    answer_en: "From upstream (upper reach)",
    context_fr: "Gravité.",
    context_en: "Gravity.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-convoi",
    question_fr: "Place des convois ?",
    question_en: "Convoys' place?",
    answer_fr: "Prioritaires sur la plaisance",
    answer_en: "Priority over pleasure craft",
    context_fr: "Commerce d'abord.",
    context_en: "Commerce first.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-garage",
    question_fr: "Que faire si on ne rentre pas ?",
    question_en: "If you don't fit in?",
    answer_fr: "Reculer et attendre l'éclusage suivant",
    answer_en: "Back out and wait next lockage",
    context_fr: "Pas de forçage.",
    context_en: "No forcing.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-longueur-utile",
    question_fr: "Longueur utile = ?",
    question_en: "Useful length = ?",
    answer_fr: "Longueur réelle disponible dans le sas",
    answer_en: "Actual usable chamber length",
    context_fr: "Mesurer son bateau.",
    context_en: "Measure your boat.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-bief",
    question_fr: "Qu'est-ce qu'un bief ?",
    question_en: "What is a reach?",
    answer_fr: "Section d'eau entre 2 écluses",
    answer_en: "Stretch of water between 2 locks",
    context_fr: "Niveau constant.",
    context_en: "Constant level.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-souille",
    question_fr: "Souille = ?",
    question_en: "Pit at lock?",
    answer_fr: "Fosse où se loge la porte busquée",
    answer_en: "Pit housing the mitre gate",
    context_fr: "Mécanique.",
    context_en: "Mechanism.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-busquee",
    question_fr: "Porte busquée ?",
    question_en: "Mitre gate?",
    answer_fr: "2 vantaux en angle vers l'amont",
    answer_en: "2 leaves angled upstream",
    context_fr: "Pression de l'eau les ferme.",
    context_en: "Water pressure closes them.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-guillotine",
    question_fr: "Porte guillotine ?",
    question_en: "Guillotine gate?",
    answer_fr: "Se lève verticalement",
    answer_en: "Lifts vertically",
    context_fr: "Grands sas modernes.",
    context_en: "Large modern locks.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-levante",
    question_fr: "Pont levant + écluse ?",
    question_en: "Lift bridge + lock?",
    answer_fr: "Coordonner les deux manœuvres",
    answer_en: "Coordinate both manoeuvres",
    context_fr: "Patience.",
    context_en: "Patience.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-eclusier",
    question_fr: "Rôle de l'éclusier ?",
    question_en: "Lock keeper's role?",
    answer_fr: "Manœuvrer et réguler le trafic",
    answer_en: "Operate and regulate traffic",
    context_fr: "Saluer / communiquer.",
    context_en: "Greet / communicate.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-sans-eclusier",
    question_fr: "Écluse libre-service ?",
    question_en: "Self-service lock?",
    answer_fr: "Activée par perche torsadée ou télécommande",
    answer_en: "Activated by twist pole or remote",
    context_fr: "VNF.",
    context_en: "French waterways.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-perche",
    question_fr: "Comment utiliser la perche ?",
    question_en: "How to use the twist pole?",
    answer_fr: "Tourner d'un quart de tour vers l'amont",
    answer_en: "Quarter turn upstream",
    context_fr: "Déclenche le cycle.",
    context_en: "Triggers cycle.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-urgence",
    question_fr: "Bouton rouge dans le sas ?",
    question_en: "Red button in chamber?",
    answer_fr: "Arrêt d'urgence — uniquement en cas de danger",
    answer_en: "Emergency stop — only in danger",
    context_fr: "Pénalité sinon.",
    context_en: "Penalty otherwise.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-sortie",
    question_fr: "Quand sortir du sas ?",
    question_en: "When to leave the chamber?",
    answer_fr: "Sur feu vert sortie",
    answer_en: "On green exit light",
    context_fr: "Pas avant.",
    context_en: "Not before.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-ecluse-double",
    question_fr: "Sas accolé / écluse double ?",
    question_en: "Twin lock?",
    answer_fr: "2 sas côte-à-côte, choisir le bon",
    answer_en: "2 chambers side by side, pick the right one",
    context_fr: "Signalisation indique.",
    context_en: "Signals indicate.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-ascenseur",
    question_fr: "Ascenseur à bateaux ?",
    question_en: "Boat lift?",
    answer_fr: "Sas mobile qui monte/descend le bateau",
    answer_en: "Mobile chamber lifting/lowering boats",
    context_fr: "Strépy-Thieu (B).",
    context_en: "Strépy-Thieu (B).",
    category: "ecluses"
  },
  {
    id: "flu-ecl-plan-incline",
    question_fr: "Plan incliné ?",
    question_en: "Inclined plane?",
    answer_fr: "Chariot transportant les bateaux sur rails",
    answer_en: "Trolley moving boats on rails",
    context_fr: "Arzviller (F).",
    context_en: "Arzviller (F).",
    category: "ecluses"
  },
  {
    id: "flu-ecl-etiage",
    question_fr: "Étiage = ?",
    question_en: "Low-water mark?",
    answer_fr: "Niveau le plus bas observé",
    answer_en: "Lowest observed level",
    context_fr: "Risque échouage.",
    context_en: "Grounding risk.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-plus-hautes",
    question_fr: "Plus Hautes Eaux Navigables (PHEN) ?",
    question_en: "Highest Navigable Waters?",
    answer_fr: "Niveau max au-dessus duquel la navigation cesse",
    answer_en: "Max level above which navigation stops",
    context_fr: "Crue.",
    context_en: "Flood.",
    category: "ecluses"
  },
  {
    id: "flu-ecl-crue",
    question_fr: "En crue rouge ?",
    question_en: "Red flood alert?",
    answer_fr: "Navigation interdite",
    answer_en: "Navigation prohibited",
    context_fr: "Sécurité.",
    context_en: "Safety.",
    category: "ecluses"
  },
  {
    id: "flu-reg-permis-puissance",
    question_fr: "Permis fluvial obligatoire à partir de quelle puissance ?",
    question_en: "River license required from what power?",
    answer_fr: "Plus de 6 CV fiscaux (≈ 4,5 kW)",
    answer_en: "Above 6 fiscal HP (~4.5 kW)",
    context_fr: "En dessous : libre.",
    context_en: "Below: free.",
    category: "reglementation"
  },
  {
    id: "flu-reg-permis-longueur",
    question_fr: "Permis exigé pour quelle longueur ?",
    question_en: "License required for what length?",
    answer_fr: "Bateaux ≤ 20 m de plaisance",
    answer_en: "Pleasure craft ≤ 20 m",
    context_fr: "Au-dessus : titre pro.",
    context_en: "Above: professional cert.",
    category: "reglementation"
  },
  {
    id: "flu-reg-permis-20",
    question_fr: "Au-delà de 20 m, quel titre ?",
    question_en: "Beyond 20 m, what title?",
    answer_fr: "Certificat de capacité pro (CdC)",
    answer_en: "Professional certificate",
    context_fr: "Catégorie spécifique.",
    context_en: "Specific category.",
    category: "reglementation"
  },
  {
    id: "flu-reg-age",
    question_fr: "Âge minimum pour le permis fluvial ?",
    question_en: "Min age for river license?",
    answer_fr: "16 ans",
    answer_en: "16 years",
    context_fr: "Réglementation FR.",
    context_en: "French rules.",
    category: "reglementation"
  },
  {
    id: "flu-reg-examen",
    question_fr: "Examen permis fluvial ?",
    question_en: "River license exam?",
    answer_fr: "QCM 30 questions, 5 erreurs max",
    answer_en: "Multiple-choice 30 Q, max 5 errors",
    context_fr: "Théorie uniquement.",
    context_en: "Theory only.",
    category: "reglementation"
  },
  {
    id: "flu-reg-formation",
    question_fr: "Formation pratique obligatoire ?",
    question_en: "Practical training required?",
    answer_fr: "Oui : minimum 3h30 sur l'eau",
    answer_en: "Yes: min 3h30 on water",
    context_fr: "Avec formateur agréé.",
    context_en: "Approved instructor.",
    category: "reglementation"
  },
  {
    id: "flu-reg-vignette",
    question_fr: "Vignette VNF ?",
    question_en: "VNF sticker?",
    answer_fr: "Péage annuel pour naviguer sur le réseau VNF",
    answer_en: "Annual toll for VNF network",
    context_fr: "Apposer sur le bateau.",
    context_en: "Stick on boat.",
    category: "reglementation"
  },
  {
    id: "flu-reg-vignette-tarif",
    question_fr: "Tarif vignette VNF plaisance ?",
    question_en: "VNF pleasure sticker price?",
    answer_fr: "Varie selon surface du bateau (m²)",
    answer_en: "Varies with boat surface (m²)",
    context_fr: "Forfaits hebdo/mensuel/annuel.",
    context_en: "Weekly/monthly/annual.",
    category: "reglementation"
  },
  {
    id: "flu-reg-immat",
    question_fr: "Immatriculation obligatoire ?",
    question_en: "Registration required?",
    answer_fr: "Oui dès qu'il y a un moteur",
    answer_en: "Yes once motorized",
    context_fr: "Plaque visible.",
    context_en: "Visible plate.",
    category: "reglementation"
  },
  {
    id: "flu-reg-carte-circulation",
    question_fr: "Carte de circulation ?",
    question_en: "Circulation card?",
    answer_fr: "Document d'identité du bateau",
    answer_en: "Boat ID document",
    context_fr: "À bord obligatoire.",
    context_en: "Mandatory onboard.",
    category: "reglementation"
  },
  {
    id: "flu-reg-assurance",
    question_fr: "Assurance obligatoire ?",
    question_en: "Insurance required?",
    answer_fr: "Recommandée mais pas obligatoire en plaisance",
    answer_en: "Recommended, not mandatory for pleasure",
    context_fr: "Sauf location/loueur.",
    context_en: "Except rentals.",
    category: "reglementation"
  },
  {
    id: "flu-reg-vitesse-canal",
    question_fr: "Vitesse max courante sur canal ?",
    question_en: "Common max speed on canal?",
    answer_fr: "6 km/h",
    answer_en: "6 km/h",
    context_fr: "Limite le batillage.",
    context_en: "Limits wash.",
    category: "reglementation"
  },
  {
    id: "flu-reg-vitesse-riviere",
    question_fr: "Vitesse max courante sur rivière ?",
    question_en: "Common max speed on river?",
    answer_fr: "10 à 30 km/h selon section",
    answer_en: "10 to 30 km/h depending on section",
    context_fr: "Voir panneaux B.6.",
    context_en: "See B.6 signs.",
    category: "reglementation"
  },
  {
    id: "flu-reg-batillage",
    question_fr: "Qu'est-ce que le batillage ?",
    question_en: "What is wash/wake?",
    answer_fr: "Vagues produites par le bateau",
    answer_en: "Waves produced by the vessel",
    context_fr: "Érode les berges.",
    context_en: "Erodes banks.",
    category: "reglementation"
  },
  {
    id: "flu-reg-droite",
    question_fr: "De quel côté navigue-t-on ?",
    question_en: "Which side of waterway?",
    answer_fr: "À droite (tribord)",
    answer_en: "To the right (starboard)",
    context_fr: "Comme la route.",
    context_en: "Like roads.",
    category: "reglementation"
  },
  {
    id: "flu-reg-croisement-tribord",
    question_fr: "Croisement de face ?",
    question_en: "Head-on crossing?",
    answer_fr: "Chacun se déporte sur sa droite (tribord)",
    answer_en: "Both bear right (starboard)",
    context_fr: "Sauf accord par signal.",
    context_en: "Unless signaled otherwise.",
    category: "reglementation"
  },
  {
    id: "flu-reg-depassement",
    question_fr: "Qui dépasse cède ?",
    question_en: "Overtaking gives way?",
    answer_fr: "Le dépassant doit éviter le dépassé",
    answer_en: "Overtaker avoids the overtaken",
    context_fr: "Côté libre.",
    context_en: "Free side.",
    category: "reglementation"
  },
  {
    id: "flu-reg-signaux-1",
    question_fr: "1 coup bref = ?",
    question_en: "1 short blast = ?",
    answer_fr: "Je viens sur tribord",
    answer_en: "I am altering to starboard",
    context_fr: "Signal manoeuvre.",
    context_en: "Manoeuvre signal.",
    category: "reglementation"
  },
  {
    id: "flu-reg-signaux-2",
    question_fr: "2 coups brefs = ?",
    question_en: "2 short blasts = ?",
    answer_fr: "Je viens sur bâbord",
    answer_en: "I am altering to port",
    context_fr: "Manœuvre.",
    context_en: "Manoeuvre.",
    category: "reglementation"
  },
  {
    id: "flu-reg-signaux-3",
    question_fr: "3 coups brefs = ?",
    question_en: "3 short blasts = ?",
    answer_fr: "Je bats en arrière",
    answer_en: "I am going astern",
    context_fr: "Marche AR.",
    context_en: "Astern.",
    category: "reglementation"
  },
  {
    id: "flu-reg-signaux-4",
    question_fr: "4 coups brefs = ?",
    question_en: "4 short blasts = ?",
    answer_fr: "Je suis incapable de manœuvrer",
    answer_en: "I cannot manoeuvre",
    context_fr: "Avarie.",
    context_en: "Breakdown.",
    category: "reglementation"
  },
  {
    id: "flu-reg-signaux-5",
    question_fr: "5 coups brefs = ?",
    question_en: "5 short blasts = ?",
    answer_fr: "Doute / danger / désaccord",
    answer_en: "Doubt / danger / disagreement",
    context_fr: "Très important.",
    context_en: "Very important.",
    category: "reglementation"
  },
  {
    id: "flu-reg-signaux-long",
    question_fr: "1 coup prolongé = ?",
    question_en: "1 prolonged blast = ?",
    answer_fr: "Attention — j'approche d'une zone de visibilité réduite",
    answer_en: "Attention — approaching restricted visibility",
    context_fr: "Courbes / sorties.",
    context_en: "Bends / exits.",
    category: "reglementation"
  },
  {
    id: "flu-reg-trois-longs",
    question_fr: "3 coups prolongés = ?",
    question_en: "3 prolonged blasts = ?",
    answer_fr: "Je vais virer (faire demi-tour)",
    answer_en: "I am turning around",
    context_fr: "Annoncer manœuvre.",
    context_en: "Announce turn.",
    category: "reglementation"
  },
  {
    id: "flu-reg-4-courts-1-long",
    question_fr: "4 brefs + 1 long ?",
    question_en: "4 short + 1 long?",
    answer_fr: "Demande d'éclusage / signal d'approche d'écluse",
    answer_en: "Lockage request / lock approach signal",
    context_fr: "Convention fluviale.",
    context_en: "River convention.",
    category: "reglementation"
  },
  {
    id: "flu-reg-rpp",
    question_fr: "Que signifie RPP ?",
    question_en: "What is RPP?",
    answer_fr: "Règlement Particulier de Police (par voie)",
    answer_en: "Local police regulation (per waterway)",
    context_fr: "Complète le RPNR.",
    context_en: "Complements RPNR.",
    category: "reglementation"
  },
  {
    id: "flu-reg-rpnr",
    question_fr: "Que signifie RPNR ?",
    question_en: "What is RPNR?",
    answer_fr: "Règlement Général de Police de la Navigation Intérieure",
    answer_en: "General Police Regulations for Inland Navigation",
    context_fr: "Texte cadre.",
    context_en: "Framework text.",
    category: "reglementation"
  },
  {
    id: "flu-reg-rgpni",
    question_fr: "Différence RPNR / RGPNI ?",
    question_en: "Difference RPNR / RGPNI?",
    answer_fr: "RGPNI = ancien texte, RPNR = nouveau (2014)",
    answer_en: "RGPNI = old, RPNR = new (2014)",
    context_fr: "Vocabulaire moderne.",
    context_en: "Modern vocabulary.",
    category: "reglementation"
  },
  {
    id: "flu-reg-vnf",
    question_fr: "Que veut dire VNF ?",
    question_en: "What does VNF mean?",
    answer_fr: "Voies Navigables de France",
    answer_en: "French Inland Waterways",
    context_fr: "Gestionnaire public.",
    context_en: "Public manager.",
    category: "reglementation"
  },
  {
    id: "flu-reg-alcool",
    question_fr: "Taux d'alcool max au commandement ?",
    question_en: "Max alcohol level for skipper?",
    answer_fr: "0,5 g/L de sang",
    answer_en: "0.5 g/L in blood",
    context_fr: "Comme route auto.",
    context_en: "Like driving.",
    category: "reglementation"
  },
  {
    id: "flu-reg-stups",
    question_fr: "Stupéfiants à bord ?",
    question_en: "Drugs on board?",
    answer_fr: "Tolérance zéro",
    answer_en: "Zero tolerance",
    context_fr: "Sanction immédiate.",
    context_en: "Immediate sanction.",
    category: "reglementation"
  },
  {
    id: "flu-reg-documents-bord",
    question_fr: "Documents à bord ?",
    question_en: "Documents on board?",
    answer_fr: "Permis, carte de circulation, vignette, assurance",
    answer_en: "License, registration, sticker, insurance",
    context_fr: "Contrôles VNF / gendarmerie.",
    context_en: "VNF / police checks.",
    category: "reglementation"
  },
  {
    id: "flu-reg-phare",
    question_fr: "Feux obligatoires de nuit ?",
    question_en: "Lights required at night?",
    answer_fr: "Oui, dès le coucher du soleil",
    answer_en: "Yes, from sunset",
    context_fr: "Visibilité.",
    context_en: "Visibility.",
    category: "reglementation"
  },
  {
    id: "flu-reg-brouillard",
    question_fr: "Navigation par brouillard ?",
    question_en: "Navigation in fog?",
    answer_fr: "Vitesse de sécurité + signaux sonores",
    answer_en: "Safe speed + sound signals",
    context_fr: "Pas de privilégié.",
    context_en: "No privileged vessel.",
    category: "reglementation"
  },
  {
    id: "flu-reg-seuil",
    question_fr: "Franchir un seuil ?",
    question_en: "Crossing a sill?",
    answer_fr: "Perpendiculaire, vitesse adaptée",
    answer_en: "Perpendicular, adapted speed",
    context_fr: "Risque échouement.",
    context_en: "Grounding risk.",
    category: "reglementation"
  },
  {
    id: "flu-reg-affluent",
    question_fr: "Sortir d'un affluent ?",
    question_en: "Exiting a tributary?",
    answer_fr: "Céder le passage à la voie principale",
    answer_en: "Give way to main waterway",
    context_fr: "B.9.",
    context_en: "B.9.",
    category: "reglementation"
  },
  {
    id: "flu-reg-port",
    question_fr: "Sortir d'un port ?",
    question_en: "Exiting a harbor?",
    answer_fr: "Céder le passage et signaler",
    answer_en: "Give way and signal",
    context_fr: "B.9 + corne.",
    context_en: "B.9 + horn.",
    category: "reglementation"
  },
  {
    id: "flu-reg-equipement-secu",
    question_fr: "Équipement sécurité plaisance fluvial ?",
    question_en: "Pleasure river safety kit?",
    answer_fr: "Gilets, écope/pompe, bouée, amarres, ancres",
    answer_en: "Lifejackets, bailer, ringbuoy, lines, anchors",
    context_fr: "Variable selon catégorie.",
    context_en: "Per category.",
    category: "reglementation"
  },
  {
    id: "flu-reg-gilet",
    question_fr: "Gilet obligatoire fluvial ?",
    question_en: "Lifejacket required?",
    answer_fr: "1 par personne à bord (≥ 50 N)",
    answer_en: "1 per person on board (≥ 50 N)",
    context_fr: "Stocké accessible.",
    context_en: "Stored accessible.",
    category: "reglementation"
  },
  {
    id: "flu-reg-enfants",
    question_fr: "Gilet pour enfants ?",
    question_en: "Lifejackets for children?",
    answer_fr: "Toujours porté à bord",
    answer_en: "Always worn on board",
    context_fr: "Sécurité.",
    context_en: "Safety.",
    category: "reglementation"
  },
  {
    id: "flu-reg-extincteur",
    question_fr: "Extincteur ?",
    question_en: "Extinguisher?",
    answer_fr: "Obligatoire dès qu'il y a moteur fixe ou installation gaz",
    answer_en: "Required if fixed engine or gas",
    context_fr: "Conforme NF.",
    context_en: "NF compliant.",
    category: "reglementation"
  },
  {
    id: "flu-reg-ecope",
    question_fr: "Écope ou pompe ?",
    question_en: "Bailer or pump?",
    answer_fr: "Obligatoire pour évacuer l'eau",
    answer_en: "Required to remove water",
    context_fr: "Sécurité.",
    context_en: "Safety.",
    category: "reglementation"
  },
  {
    id: "flu-reg-ancre",
    question_fr: "Ancre obligatoire ?",
    question_en: "Anchor required?",
    answer_fr: "Oui, avec ligne adaptée",
    answer_en: "Yes, with suitable line",
    context_fr: "Mouillage d'urgence.",
    context_en: "Emergency anchoring.",
    category: "reglementation"
  },
  {
    id: "flu-reg-phare-portatif",
    question_fr: "Lampe étanche ?",
    question_en: "Waterproof torch?",
    answer_fr: "Obligatoire la nuit",
    answer_en: "Required at night",
    context_fr: "Signalisation d'urgence.",
    context_en: "Emergency signal.",
    category: "reglementation"
  },
  {
    id: "flu-reg-sifflet",
    question_fr: "Sifflet ?",
    question_en: "Whistle?",
    answer_fr: "Recommandé pour appel à l'aide",
    answer_en: "Recommended for help call",
    context_fr: "Léger.",
    context_en: "Light.",
    category: "reglementation"
  },
  {
    id: "flu-reg-trousse",
    question_fr: "Trousse de secours ?",
    question_en: "First-aid kit?",
    answer_fr: "Recommandée à bord",
    answer_en: "Recommended on board",
    context_fr: "Premiers soins.",
    context_en: "First aid.",
    category: "reglementation"
  },
  {
    id: "flu-reg-dechets",
    question_fr: "Rejet des déchets ?",
    question_en: "Waste disposal?",
    answer_fr: "Interdit — tout ramener à terre",
    answer_en: "Prohibited — bring all back",
    context_fr: "Convention environnementale.",
    context_en: "Environment rules.",
    category: "reglementation"
  },
  {
    id: "flu-reg-eaux-noires",
    question_fr: "Eaux noires / WC ?",
    question_en: "Black water / heads?",
    answer_fr: "Cuves obligatoires, vider en station",
    answer_en: "Holding tanks required, empty at station",
    context_fr: "Pas dans la voie d'eau.",
    context_en: "Not into waterway.",
    category: "reglementation"
  },
  {
    id: "flu-reg-eaux-grises",
    question_fr: "Eaux grises (vaisselle) ?",
    question_en: "Grey water (dishes)?",
    answer_fr: "Produits biodégradables imposés",
    answer_en: "Biodegradable products only",
    context_fr: "Protection berges.",
    context_en: "Bank protection.",
    category: "reglementation"
  },
  {
    id: "flu-reg-hauteur-air",
    question_fr: "Tirant d'air ?",
    question_en: "Air draft?",
    answer_fr: "Hauteur entre flottaison et point haut",
    answer_en: "Height from waterline to top",
    context_fr: "Pour ponts.",
    context_en: "For bridges.",
    category: "reglementation"
  },
  {
    id: "flu-nav-avalant",
    question_fr: "Bateau « avalant » ?",
    question_en: "'Downstream' vessel?",
    answer_fr: "Descend le courant",
    answer_en: "Goes with the current",
    context_fr: "Prioritaire.",
    context_en: "Priority.",
    category: "navigation"
  },
  {
    id: "flu-nav-montant",
    question_fr: "Bateau « montant » ?",
    question_en: "'Upstream' vessel?",
    answer_fr: "Remonte le courant",
    answer_en: "Goes against current",
    context_fr: "Cède au montant.",
    context_en: "Yields.",
    category: "navigation"
  },
  {
    id: "flu-nav-tirant-eau",
    question_fr: "Tirant d'eau ?",
    question_en: "Draft?",
    answer_fr: "Profondeur immergée sous la flottaison",
    answer_en: "Submerged depth",
    context_fr: "Comparer aux mouillages.",
    context_en: "Compare to depths.",
    category: "navigation"
  },
  {
    id: "flu-nav-franc-bord",
    question_fr: "Franc-bord ?",
    question_en: "Freeboard?",
    answer_fr: "Hauteur du pont au-dessus de l'eau",
    answer_en: "Deck height above water",
    context_fr: "Stabilité.",
    context_en: "Stability.",
    category: "navigation"
  },
  {
    id: "flu-nav-rouf",
    question_fr: "Rouf ?",
    question_en: "Cabin top?",
    answer_fr: "Superstructure abritant la cabine",
    answer_en: "Cabin superstructure",
    context_fr: "Confort.",
    context_en: "Comfort.",
    category: "navigation"
  },
  {
    id: "flu-nav-etrave",
    question_fr: "Étrave ?",
    question_en: "Bow stem?",
    answer_fr: "Avant du bateau",
    answer_en: "Front of boat",
    context_fr: "Fend l'eau.",
    context_en: "Cuts water.",
    category: "navigation"
  },
  {
    id: "flu-nav-etambot",
    question_fr: "Étambot ?",
    question_en: "Sternpost?",
    answer_fr: "Arrière du bateau (axe gouvernail)",
    answer_en: "Back of boat (rudder axis)",
    context_fr: "Tenue de cap.",
    context_en: "Course holding.",
    category: "navigation"
  },
  {
    id: "flu-nav-babord",
    question_fr: "Bâbord ?",
    question_en: "Port?",
    answer_fr: "Côté gauche en regardant vers l'avant",
    answer_en: "Left side facing forward",
    context_fr: "Rouge.",
    context_en: "Red.",
    category: "navigation"
  },
  {
    id: "flu-nav-tribord",
    question_fr: "Tribord ?",
    question_en: "Starboard?",
    answer_fr: "Côté droit en regardant vers l'avant",
    answer_en: "Right side facing forward",
    context_fr: "Vert.",
    context_en: "Green.",
    category: "navigation"
  },
  {
    id: "flu-nav-proue",
    question_fr: "Proue ?",
    question_en: "Bow?",
    answer_fr: "Avant du bateau",
    answer_en: "Front",
    context_fr: "Synonyme étrave.",
    context_en: "Synonym.",
    category: "navigation"
  },
  {
    id: "flu-nav-poupe",
    question_fr: "Poupe ?",
    question_en: "Stern?",
    answer_fr: "Arrière du bateau",
    answer_en: "Back of boat",
    context_fr: "Synonyme arrière.",
    context_en: "Synonym.",
    category: "navigation"
  },
  {
    id: "flu-nav-safran",
    question_fr: "Safran ?",
    question_en: "Rudder blade?",
    answer_fr: "Surface immergée du gouvernail",
    answer_en: "Submerged rudder surface",
    context_fr: "Dirige.",
    context_en: "Steers.",
    category: "navigation"
  },
  {
    id: "flu-nav-barre",
    question_fr: "Barre ?",
    question_en: "Helm?",
    answer_fr: "Volant ou barre franche pour diriger",
    answer_en: "Wheel or tiller",
    context_fr: "Commande direction.",
    context_en: "Steering.",
    category: "navigation"
  },
  {
    id: "flu-nav-amarre",
    question_fr: "Amarre ?",
    question_en: "Mooring line?",
    answer_fr: "Cordage pour fixer le bateau",
    answer_en: "Rope to secure boat",
    context_fr: "Bollards / taquets.",
    context_en: "Bollards/cleats.",
    category: "navigation"
  },
  {
    id: "flu-nav-garde",
    question_fr: "Garde montante / avalante ?",
    question_en: "Spring lines?",
    answer_fr: "Empêchent le bateau d'avancer/reculer",
    answer_en: "Prevent fore/aft movement",
    context_fr: "Indispensables au sas.",
    context_en: "Essential at locks.",
    category: "navigation"
  },
  {
    id: "flu-nav-nuit-blanc",
    question_fr: "Feu blanc seul ?",
    question_en: "White light only?",
    answer_fr: "Bateau au mouillage / petit bateau",
    answer_en: "Anchored / small craft",
    context_fr: "Visible 360°.",
    context_en: "All-round.",
    category: "navigation"
  },
  {
    id: "flu-nav-feux-route",
    question_fr: "Feux de route bateau à moteur < 20 m ?",
    question_en: "Lights of motor vessel < 20 m?",
    answer_fr: "Bâbord rouge, tribord vert, blanc mâture, blanc poupe",
    answer_en: "Port red, starboard green, white masthead, white stern",
    context_fr: "Standard CEVNI.",
    context_en: "CEVNI standard.",
    category: "navigation"
  },
  {
    id: "flu-nav-convoi-feux",
    question_fr: "Feux d'un convoi poussé ?",
    question_en: "Pushed convoy lights?",
    answer_fr: "3 feux blancs en triangle à l'avant",
    answer_en: "3 white masthead lights in triangle",
    context_fr: "Visible de loin.",
    context_en: "Visible far.",
    category: "navigation"
  },
  {
    id: "flu-nav-feu-pavillon-bleu",
    question_fr: "Pavillon bleu / scintillant blanc ?",
    question_en: "Blue flag / flashing white?",
    answer_fr: "Demande de croisement à contre-bord (tribord/tribord)",
    answer_en: "Request to pass starboard-to-starboard",
    context_fr: "Inhabituel, à confirmer.",
    context_en: "Unusual, confirm.",
    category: "navigation"
  },
  {
    id: "flu-nav-priorite-voile",
    question_fr: "Voilier vs moteur en fluvial ?",
    question_en: "Sail vs motor on river?",
    answer_fr: "Le moteur reste souvent prioritaire (chenal étroit)",
    answer_en: "Motor often priority (narrow channel)",
    context_fr: "Sauf voie large.",
    context_en: "Except wide waters.",
    category: "navigation"
  },
  {
    id: "flu-nav-priorite-aviron",
    question_fr: "Aviron / kayak vs moteur ?",
    question_en: "Rowing / kayak vs motor?",
    answer_fr: "Le motorisé doit s'écarter",
    answer_en: "Motor must keep clear",
    context_fr: "Petites embarcations.",
    context_en: "Small craft.",
    category: "navigation"
  },
  {
    id: "flu-nav-nage",
    question_fr: "Nage / baignade ?",
    question_en: "Swimming?",
    answer_fr: "Interdite dans le chenal et près des écluses",
    answer_en: "Forbidden in channel and near locks",
    context_fr: "Très dangereux.",
    context_en: "Very dangerous.",
    category: "navigation"
  },
  {
    id: "flu-nav-manoeuvre",
    question_fr: "Manœuvre en marche arrière ?",
    question_en: "Reversing?",
    answer_fr: "Lente, avec vigie, signal sonore",
    answer_en: "Slow, with lookout, sound signal",
    context_fr: "3 coups brefs.",
    context_en: "3 short blasts.",
    category: "navigation"
  },
  {
    id: "flu-nav-amarre-bollard",
    question_fr: "Tour mort + 2 demi-clés ?",
    question_en: "Round turn + 2 half hitches?",
    answer_fr: "Nœud d'amarrage classique sur bollard",
    answer_en: "Classic mooring knot",
    context_fr: "Solide, défait facilement.",
    context_en: "Strong, easy to release.",
    category: "navigation"
  },
  {
    id: "flu-nav-noeud-cabestan",
    question_fr: "Nœud de cabestan ?",
    question_en: "Clove hitch?",
    answer_fr: "Utilisé pour défenses ou amarrage rapide",
    answer_en: "Used for fenders or quick mooring",
    context_fr: "Glisse sous charge.",
    context_en: "Slips under load.",
    category: "navigation"
  },
  {
    id: "flu-nav-noeud-8",
    question_fr: "Nœud en huit ?",
    question_en: "Figure-8?",
    answer_fr: "Stoppeur en bout de cordage",
    answer_en: "Stopper at line end",
    context_fr: "Évite passage poulie.",
    context_en: "Prevents running.",
    category: "navigation"
  },
  {
    id: "flu-nav-noeud-chaise",
    question_fr: "Nœud de chaise ?",
    question_en: "Bowline?",
    answer_fr: "Boucle qui ne serre pas, indispensable",
    answer_en: "Non-tightening loop, essential",
    context_fr: "Roi des nœuds.",
    context_en: "King of knots.",
    category: "navigation"
  },
  {
    id: "flu-nav-defenses",
    question_fr: "Défenses ?",
    question_en: "Fenders?",
    answer_fr: "Pare-battages entre bateau et quai",
    answer_en: "Buffers between boat and dock",
    context_fr: "Protection coque.",
    context_en: "Hull protection.",
    category: "navigation"
  },
  {
    id: "flu-nav-gaffe",
    question_fr: "Gaffe ?",
    question_en: "Boat hook?",
    answer_fr: "Perche avec crochet pour manœuvres",
    answer_en: "Hook pole for manoeuvres",
    context_fr: "Récupère amarres.",
    context_en: "Catches lines.",
    category: "navigation"
  },
  {
    id: "flu-nav-carte-marine",
    question_fr: "Carte fluviale ?",
    question_en: "River chart?",
    answer_fr: "Document avec PK, écluses, ouvrages",
    answer_en: "Document with PK, locks, structures",
    context_fr: "Indispensable.",
    context_en: "Essential.",
    category: "navigation"
  },
  {
    id: "flu-nav-guide-vagnon",
    question_fr: "Guide Vagnon / Navicarte ?",
    question_en: "Vagnon / Navicarte guide?",
    answer_fr: "Cartes-guides détaillées de la voie d'eau",
    answer_en: "Detailed waterway guides",
    context_fr: "Outil pratique.",
    context_en: "Practical tool.",
    category: "navigation"
  },
  {
    id: "flu-nav-courant",
    question_fr: "Effet du courant en manœuvre ?",
    question_en: "Effect of current on manoeuvres?",
    answer_fr: "Dérive le bateau, anticiper",
    answer_en: "Drifts boat, anticipate",
    context_fr: "Toujours observer.",
    context_en: "Always observe.",
    category: "navigation"
  },
  {
    id: "flu-nav-vent",
    question_fr: "Effet du vent ?",
    question_en: "Effect of wind?",
    answer_fr: "Pousse les œuvres mortes (haut)",
    answer_en: "Pushes superstructure",
    context_fr: "Influence accostage.",
    context_en: "Affects docking.",
    category: "navigation"
  },
  {
    id: "flu-nav-derive",
    question_fr: "Dérive ?",
    question_en: "Leeway?",
    answer_fr: "Décalage latéral dû au vent/courant",
    answer_en: "Lateral drift due to wind/current",
    context_fr: "Corriger cap.",
    context_en: "Adjust heading.",
    category: "navigation"
  },
  {
    id: "flu-nav-evite",
    question_fr: "« Évitage » ?",
    question_en: "'Swinging round anchor'?",
    answer_fr: "Tour complet autour de l'ancre selon vent/courant",
    answer_en: "Full swing around anchor",
    context_fr: "Prévoir l'espace.",
    context_en: "Plan space.",
    category: "navigation"
  },
  {
    id: "flu-nav-amarrage-couple",
    question_fr: "Amarrage à couple ?",
    question_en: "Rafted mooring?",
    answer_fr: "Plusieurs bateaux côte-à-côte",
    answer_en: "Several boats side by side",
    context_fr: "Demander autorisation.",
    context_en: "Ask permission.",
    category: "navigation"
  },
  {
    id: "flu-nav-rive-droite",
    question_fr: "Rive droite ?",
    question_en: "Right bank?",
    answer_fr: "En descendant le courant, à droite",
    answer_en: "On right when going downstream",
    context_fr: "Convention universelle.",
    context_en: "Universal rule.",
    category: "navigation"
  },
  {
    id: "flu-nav-rive-gauche",
    question_fr: "Rive gauche ?",
    question_en: "Left bank?",
    answer_fr: "En descendant le courant, à gauche",
    answer_en: "On left when going downstream",
    context_fr: "Convention.",
    context_en: "Convention.",
    category: "navigation"
  },
  {
    id: "flu-nav-amont",
    question_fr: "Amont = ?",
    question_en: "Upstream = ?",
    answer_fr: "Vers la source",
    answer_en: "Toward the source",
    context_fr: "Sens du courant inverse.",
    context_en: "Against current.",
    category: "navigation"
  },
  {
    id: "flu-nav-aval",
    question_fr: "Aval = ?",
    question_en: "Downstream = ?",
    answer_fr: "Vers l'embouchure",
    answer_en: "Toward the mouth",
    context_fr: "Sens du courant.",
    context_en: "With current.",
    category: "navigation"
  },
  {
    id: "flu-nav-chenal",
    question_fr: "Chenal navigable ?",
    question_en: "Navigable channel?",
    answer_fr: "Partie balisée et entretenue",
    answer_en: "Marked, maintained part",
    context_fr: "Profondeur garantie.",
    context_en: "Guaranteed depth.",
    category: "navigation"
  },
  {
    id: "flu-nav-hors-chenal",
    question_fr: "Hors chenal ?",
    question_en: "Outside channel?",
    answer_fr: "Risque échouement, hauts-fonds",
    answer_en: "Grounding, shallows",
    context_fr: "Rester dans le chenal.",
    context_en: "Stay in channel.",
    category: "navigation"
  },
  {
    id: "flu-nav-croisement-cassis",
    question_fr: "Passer un cassis / déversoir ?",
    question_en: "Crossing a weir/spillway?",
    answer_fr: "Interdit côté aval",
    answer_en: "Forbidden on downstream side",
    context_fr: "Très dangereux.",
    context_en: "Very dangerous.",
    category: "navigation"
  },
  {
    id: "flu-nav-pont-arche",
    question_fr: "Pont à plusieurs arches ?",
    question_en: "Multi-arch bridge?",
    answer_fr: "Suivre l'arche balisée",
    answer_en: "Use marked arch",
    context_fr: "Panneaux à proximité.",
    context_en: "Signs nearby.",
    category: "navigation"
  },
  {
    id: "flu-nav-pont-mobile",
    question_fr: "Pont mobile ?",
    question_en: "Movable bridge?",
    answer_fr: "Attendre l'ouverture avant de passer",
    answer_en: "Wait for opening before passing",
    context_fr: "Horaires affichés.",
    context_en: "Posted hours.",
    category: "navigation"
  },
  {
    id: "flu-nav-tunnel",
    question_fr: "Traversée de tunnel ?",
    question_en: "Tunnel crossing?",
    answer_fr: "Feux d'autorisation, sens alterné",
    answer_en: "Signals, alternating direction",
    context_fr: "Patience.",
    context_en: "Patience.",
    category: "navigation"
  },
  {
    id: "flu-nav-siphon",
    question_fr: "Siphon ?",
    question_en: "Siphon?",
    answer_fr: "Ouvrage hydraulique souterrain",
    answer_en: "Underground hydraulic structure",
    context_fr: "Pas navigable.",
    context_en: "Not navigable.",
    category: "navigation"
  },
  {
    id: "flu-nav-ouvrage",
    question_fr: "Ouvrage d'art ?",
    question_en: "Engineering structure?",
    answer_fr: "Pont, écluse, barrage, etc.",
    answer_en: "Bridge, lock, dam, etc.",
    context_fr: "Vocabulaire VNF.",
    context_en: "VNF wording.",
    category: "navigation"
  },
  {
    id: "flu-nav-derrick",
    question_fr: "Drague / chantier ?",
    question_en: "Dredger / works?",
    answer_fr: "Passer du côté indiqué par les feux/pavillons",
    answer_en: "Pass on signaled side",
    context_fr: "Lentement.",
    context_en: "Slowly.",
    category: "navigation"
  },
  {
    id: "flu-nav-convoi-pousse",
    question_fr: "Convoi poussé ?",
    question_en: "Pushed convoy?",
    answer_fr: "Pousseur + barges, jusqu'à 180 m",
    answer_en: "Pusher + barges, up to 180 m",
    context_fr: "Très inertes.",
    context_en: "Very heavy.",
    category: "navigation"
  },
  {
    id: "flu-nav-convoi-remor",
    question_fr: "Convoi remorqué ?",
    question_en: "Towed convoy?",
    answer_fr: "Bateaux tirés par un remorqueur",
    answer_en: "Boats pulled by tug",
    context_fr: "Câble tendu.",
    context_en: "Taut cable.",
    category: "navigation"
  },
  {
    id: "flu-nav-haute-mer",
    question_fr: "Bateau venant de la mer ?",
    question_en: "Boat from sea?",
    answer_fr: "Doit respecter le règlement fluvial à l'entrée",
    answer_en: "Must follow river rules on entry",
    context_fr: "RIPAM s'arrête.",
    context_en: "COLREGS stop.",
    category: "navigation"
  },
  {
    id: "flu-nav-rotation",
    question_fr: "Tour à virer = ?",
    question_en: "Turning circle?",
    answer_fr: "Espace nécessaire pour faire demi-tour",
    answer_en: "Space needed to turn around",
    context_fr: "Vérifier marges.",
    context_en: "Check clearance.",
    category: "navigation"
  },
  {
    id: "flu-nav-ralenti",
    question_fr: "Ralentir = ?",
    question_en: "Slowing down?",
    answer_fr: "Réduire les remous, surtout près des bateaux amarrés",
    answer_en: "Reduce wash, esp. near moored boats",
    context_fr: "Politesse + sécurité.",
    context_en: "Courtesy + safety.",
    category: "navigation"
  },
  {
    id: "flu-nav-zone-port",
    question_fr: "Zone portuaire ?",
    question_en: "Port zone?",
    answer_fr: "Vitesse limitée + manœuvres prudentes",
    answer_en: "Speed limit + prudent manoeuvres",
    context_fr: "Beaucoup de trafic.",
    context_en: "Heavy traffic.",
    category: "navigation"
  },
  {
    id: "flu-nav-zone-baignade",
    question_fr: "Zone de baignade ?",
    question_en: "Swim zone?",
    answer_fr: "Interdiction d'approche aux bateaux",
    answer_en: "Boats prohibited",
    context_fr: "Bouées délimitent.",
    context_en: "Buoys mark it.",
    category: "navigation"
  },
  {
    id: "flu-nav-sortie-affluent",
    question_fr: "Sortir d'un affluent étroit ?",
    question_en: "Exiting narrow tributary?",
    answer_fr: "Émettre un coup long avant",
    answer_en: "Long blast before",
    context_fr: "Signaler présence.",
    context_en: "Signal presence.",
    category: "navigation"
  },
  {
    id: "flu-nav-courbe",
    question_fr: "Aborder une courbe sans visibilité ?",
    question_en: "Approaching a blind bend?",
    answer_fr: "Garder sa droite + signal long",
    answer_en: "Stay right + long blast",
    context_fr: "Annoncer.",
    context_en: "Announce.",
    category: "navigation"
  },
  {
    id: "flu-nav-croisement-grand",
    question_fr: "Croisement avec convoi ?",
    question_en: "Crossing a convoy?",
    answer_fr: "S'écarter et leur laisser le chenal",
    answer_en: "Move aside, leave channel",
    context_fr: "Politesse fluviale.",
    context_en: "River courtesy.",
    category: "navigation"
  },
  {
    id: "flu-sec-mob",
    question_fr: "Homme à l'eau ?",
    question_en: "MOB?",
    answer_fr: "Crier, jeter bouée, manœuvrer, ne pas sauter",
    answer_en: "Shout, throw buoy, manoeuvre, don't jump",
    context_fr: "Risque double noyade.",
    context_en: "Risk of double drowning.",
    category: "securite"
  },
  {
    id: "flu-sec-gilet-port",
    question_fr: "Gilet quand porter ?",
    question_en: "When to wear lifejacket?",
    answer_fr: "En navigation à risque, enfants toujours",
    answer_en: "In risk areas, children always",
    context_fr: "Bonne pratique : toujours.",
    context_en: "Best practice: always.",
    category: "securite"
  },
  {
    id: "flu-sec-hypothermie",
    question_fr: "Hypothermie ?",
    question_en: "Hypothermia?",
    answer_fr: "Chute corporelle de température en eau froide",
    answer_en: "Body temp drop in cold water",
    context_fr: "Ressortir vite.",
    context_en: "Get out fast.",
    category: "securite"
  },
  {
    id: "flu-sec-vfi-50N",
    question_fr: "Gilet 50 N ?",
    question_en: "50 N buoyancy aid?",
    answer_fr: "Aide à la flottabilité (eaux calmes)",
    answer_en: "Buoyancy aid (calm waters)",
    context_fr: "Pas de retournement.",
    context_en: "No self-righting.",
    category: "securite"
  },
  {
    id: "flu-sec-vfi-100N",
    question_fr: "Gilet 100 N ?",
    question_en: "100 N lifejacket?",
    answer_fr: "Retourne nageur léger, eaux abritées",
    answer_en: "Turns light swimmer, sheltered waters",
    context_fr: "Standard plaisance.",
    context_en: "Pleasure standard.",
    category: "securite"
  },
  {
    id: "flu-sec-vfi-150N",
    question_fr: "Gilet 150 N ?",
    question_en: "150 N lifejacket?",
    answer_fr: "Retourne nageur habillé, large",
    answer_en: "Turns clothed swimmer, offshore",
    context_fr: "Pas obligatoire fluvial.",
    context_en: "Not required inland.",
    category: "securite"
  },
  {
    id: "flu-sec-incendie",
    question_fr: "Incendie à bord ?",
    question_en: "Fire on board?",
    answer_fr: "Couper carburant + gaz, extincteur, alerter",
    answer_en: "Cut fuel + gas, extinguisher, alert",
    context_fr: "Bateau = bois/fibres.",
    context_en: "Boats burn fast.",
    category: "securite"
  },
  {
    id: "flu-sec-voie-eau",
    question_fr: "Voie d'eau ?",
    question_en: "Water ingress?",
    answer_fr: "Localiser, étoupe/colmater, pompage, alerte",
    answer_en: "Locate, plug, pump, alert",
    context_fr: "Préventif : vannes fermées.",
    context_en: "Preventive: valves closed.",
    category: "securite"
  },
  {
    id: "flu-sec-vhf-app",
    question_fr: "Appel d'urgence VHF ?",
    question_en: "VHF emergency call?",
    answer_fr: "MAYDAY MAYDAY MAYDAY sur canal 16",
    answer_en: "MAYDAY x3 on channel 16",
    context_fr: "Pour les zones couvertes.",
    context_en: "Where covered.",
    category: "securite"
  },
  {
    id: "flu-sec-vhf-fluvial",
    question_fr: "VHF utile en fluvial ?",
    question_en: "Useful VHF on river?",
    answer_fr: "Pour écluses, ponts, capitaineries",
    answer_en: "For locks, bridges, harbor offices",
    context_fr: "Canal local indiqué.",
    context_en: "Local channel posted.",
    category: "securite"
  },
  {
    id: "flu-sec-crr",
    question_fr: "CRR utile ?",
    question_en: "CRR useful?",
    answer_fr: "Obligatoire pour utiliser une VHF marine",
    answer_en: "Required to use marine VHF",
    context_fr: "Pas pour la VHF fluviale interne.",
    context_en: "Not for internal river VHF.",
    category: "securite"
  },
  {
    id: "flu-sec-ati",
    question_fr: "ATIS = ?",
    question_en: "ATIS?",
    answer_fr: "Automatic Transmitter Identification System",
    answer_en: "Automatic Transmitter Identification System",
    context_fr: "Programmé dans VHF fluviale.",
    context_en: "Programmed in river VHF.",
    category: "securite"
  },
  {
    id: "flu-sec-18",
    question_fr: "Permis radio fluvial spécifique ?",
    question_en: "Specific river radio permit?",
    answer_fr: "CRR + ATIS pour le réseau intérieur",
    answer_en: "CRR + ATIS for inland network",
    context_fr: "Norme européenne.",
    context_en: "European norm.",
    category: "securite"
  },
  {
    id: "flu-sec-noyade",
    question_fr: "Noyade — premiers secours ?",
    question_en: "Drowning — first aid?",
    answer_fr: "Sortir, PLS, alerter 196",
    answer_en: "Out, recovery pos, call 196",
    context_fr: "112 si CROSS indisponible.",
    context_en: "112 if no CROSS.",
    category: "securite"
  },
  {
    id: "flu-sec-196",
    question_fr: "Numéro d'urgence en mer ?",
    question_en: "Sea emergency number?",
    answer_fr: "196 (CROSS) ou 112",
    answer_en: "196 (CROSS) or 112",
    context_fr: "Côtier surtout.",
    context_en: "Mainly coastal.",
    category: "securite"
  },
  {
    id: "flu-sec-urgence-fluvial",
    question_fr: "Urgence fluviale ?",
    question_en: "River emergency?",
    answer_fr: "112 (général) ou éclusier le plus proche",
    answer_en: "112 (general) or nearest lock keeper",
    context_fr: "Pompiers / SAMU.",
    context_en: "Fire / EMT.",
    category: "securite"
  },
  {
    id: "flu-sec-incident-decla",
    question_fr: "Déclaration d'incident ?",
    question_en: "Incident report?",
    answer_fr: "Obligatoire à VNF en cas de dommages",
    answer_en: "Mandatory to VNF if damage",
    context_fr: "Formulaire CERFA.",
    context_en: "CERFA form.",
    category: "securite"
  },
  {
    id: "flu-sec-collision",
    question_fr: "Collision ?",
    question_en: "Collision?",
    answer_fr: "Constater, assurer secours, déclarer",
    answer_en: "Note, assist, declare",
    context_fr: "Ne jamais fuir.",
    context_en: "Never flee.",
    category: "securite"
  },
  {
    id: "flu-sec-echouement",
    question_fr: "Échouement léger ?",
    question_en: "Mild grounding?",
    answer_fr: "Pas de marche AR brusque — sonder, équilibrer",
    answer_en: "No abrupt reverse — sound, balance",
    context_fr: "Risque hélice.",
    context_en: "Propeller risk.",
    category: "securite"
  },
  {
    id: "flu-sec-plongeur",
    question_fr: "Drapeau A (blanc/bleu) ?",
    question_en: "Flag A (white/blue)?",
    answer_fr: "Plongeur à l'eau — passer au large",
    answer_en: "Diver in water — keep clear",
    context_fr: "Vitesse réduite.",
    context_en: "Reduced speed.",
    category: "securite"
  },
  {
    id: "flu-sec-orage",
    question_fr: "Orage en navigation ?",
    question_en: "Thunderstorm?",
    answer_fr: "S'abriter, couper antenne VHF",
    answer_en: "Take shelter, disconnect VHF antenna",
    context_fr: "Foudre.",
    context_en: "Lightning.",
    category: "securite"
  },
  {
    id: "flu-sec-brouillard-securite",
    question_fr: "Brouillard — règle ?",
    question_en: "Fog — rule?",
    answer_fr: "Vitesse de sécurité + corne 1 long / minute",
    answer_en: "Safe speed + 1 long blast / minute",
    context_fr: "Pas de privilégié.",
    context_en: "No privileged.",
    category: "securite"
  },
  {
    id: "flu-sec-vetements",
    question_fr: "Vêtements adaptés ?",
    question_en: "Suitable clothing?",
    answer_fr: "Chaussures fermées non glissantes",
    answer_en: "Closed non-slip shoes",
    context_fr: "Pas de tongs.",
    context_en: "No flip-flops.",
    category: "securite"
  },
  {
    id: "flu-sec-enfants-secu",
    question_fr: "Enfants à bord ?",
    question_en: "Children on board?",
    answer_fr: "Surveillance permanente + gilet porté",
    answer_en: "Constant watch + worn jacket",
    context_fr: "Toujours.",
    context_en: "Always.",
    category: "securite"
  },
  {
    id: "flu-sec-alcool-secu",
    question_fr: "Alcool à bord ?",
    question_en: "Alcohol on board?",
    answer_fr: "Augmente les risques (équilibre, jugement)",
    answer_en: "Increases risks",
    context_fr: "Modération.",
    context_en: "Moderation.",
    category: "securite"
  },
  {
    id: "flu-sec-medic",
    question_fr: "Médicaments + barre ?",
    question_en: "Meds + helm?",
    answer_fr: "Effets secondaires possibles",
    answer_en: "Possible side effects",
    context_fr: "Vérifier notice.",
    context_en: "Check leaflet.",
    category: "securite"
  },
  {
    id: "flu-sec-nuit-loisirs",
    question_fr: "Navigation de nuit en plaisance fluviale ?",
    question_en: "Pleasure night navigation?",
    answer_fr: "Souvent interdite hors zones autorisées",
    answer_en: "Often forbidden outside permitted areas",
    context_fr: "RPP local.",
    context_en: "Local RPP.",
    category: "securite"
  },
  {
    id: "flu-sec-brulure",
    question_fr: "Brûlure moteur ?",
    question_en: "Engine burn?",
    answer_fr: "Eau froide 15 min, pas de gras",
    answer_en: "Cold water 15 min, no fat",
    context_fr: "Couvrir propre.",
    context_en: "Cover clean.",
    category: "securite"
  },
  {
    id: "flu-sec-coupure",
    question_fr: "Coupure profonde ?",
    question_en: "Deep cut?",
    answer_fr: "Compresser, surélever, alerter",
    answer_en: "Compress, elevate, alert",
    context_fr: "Pansement propre.",
    context_en: "Clean dressing.",
    category: "securite"
  },
  {
    id: "flu-sec-electrocution",
    question_fr: "Risque électrique à bord ?",
    question_en: "Electrical risk?",
    answer_fr: "Couper le disjoncteur avant intervention",
    answer_en: "Cut breaker before action",
    context_fr: "Eau + 220V = danger.",
    context_en: "Water + 220V = danger.",
    category: "securite"
  },
  {
    id: "flu-sec-co",
    question_fr: "Monoxyde de carbone ?",
    question_en: "Carbon monoxide?",
    answer_fr: "Gaz inodore mortel — ventiler",
    answer_en: "Odorless deadly gas — ventilate",
    context_fr: "Détecteur recommandé.",
    context_en: "Detector recommended.",
    category: "securite"
  },
  {
    id: "flu-sec-gaz",
    question_fr: "Bouteille gaz ?",
    question_en: "Gas bottle?",
    answer_fr: "Coffre étanche ventilé bas",
    answer_en: "Sealed locker, low vent",
    context_fr: "Propane plus lourd que l'air.",
    context_en: "Propane heavier than air.",
    category: "securite"
  },
  {
    id: "flu-sec-carburant",
    question_fr: "Avitaillement carburant ?",
    question_en: "Refueling?",
    answer_fr: "Couper moteur + interdiction de fumer",
    answer_en: "Engine off + no smoking",
    context_fr: "Aération avant redémarrage.",
    context_en: "Vent before restart.",
    category: "securite"
  },
  {
    id: "flu-sec-ventilation",
    question_fr: "Ventilation compartiment moteur ?",
    question_en: "Engine bay vent?",
    answer_fr: "5 minutes avant démarrage",
    answer_en: "5 minutes before start",
    context_fr: "Évite explosion vapeurs.",
    context_en: "Prevents vapour explosion.",
    category: "securite"
  },
  {
    id: "flu-sec-blackout",
    question_fr: "Panne électrique ?",
    question_en: "Power blackout?",
    answer_fr: "Lampe étanche + amarrage sécurisé",
    answer_en: "Torch + secure mooring",
    context_fr: "Prévoir batterie de secours.",
    context_en: "Backup battery.",
    category: "securite"
  },
  {
    id: "flu-sec-avarie-moteur",
    question_fr: "Avarie moteur ?",
    question_en: "Engine failure?",
    answer_fr: "Mouiller l'ancre si danger",
    answer_en: "Drop anchor if danger",
    context_fr: "Éviter dérive.",
    context_en: "Avoid drift.",
    category: "securite"
  },
  {
    id: "flu-sec-perte-direction",
    question_fr: "Perte de gouverne ?",
    question_en: "Steering loss?",
    answer_fr: "Mouillage immédiat, signal 4 coups brefs",
    answer_en: "Immediate anchor, 4 short blasts",
    context_fr: "Cas grave.",
    context_en: "Serious case.",
    category: "securite"
  },
  {
    id: "flu-sec-anti-pollu",
    question_fr: "Hydrocarbures à l'eau ?",
    question_en: "Fuel in water?",
    answer_fr: "Confiner + alerter VNF",
    answer_en: "Contain + alert VNF",
    context_fr: "Pénal.",
    context_en: "Criminal offence.",
    category: "securite"
  },
  {
    id: "flu-sec-vidange",
    question_fr: "Vidange moteur ?",
    question_en: "Engine oil change?",
    answer_fr: "Récupérer huile usagée à terre",
    answer_en: "Collect used oil ashore",
    context_fr: "Jamais dans l'eau.",
    context_en: "Never in water.",
    category: "securite"
  },
  {
    id: "flu-sec-eau-potable",
    question_fr: "Réserve d'eau potable ?",
    question_en: "Drinking water tank?",
    answer_fr: "Vérifier propreté & date remplissage",
    answer_en: "Check cleanliness & date",
    context_fr: "Désinfecter régulièrement.",
    context_en: "Disinfect regularly.",
    category: "securite"
  },
  {
    id: "flu-sec-trousse-secu",
    question_fr: "Composition trousse de secours fluvial ?",
    question_en: "River first-aid kit?",
    answer_fr: "Pansements, désinfectant, couverture, gants",
    answer_en: "Dressings, antiseptic, blanket, gloves",
    context_fr: "Standard randonnée.",
    context_en: "Hiking standard.",
    category: "securite"
  },
  {
    id: "flu-sec-plan-secours",
    question_fr: "Plan de secours équipage ?",
    question_en: "Crew emergency plan?",
    answer_fr: "Briefing avant départ",
    answer_en: "Briefing before departure",
    context_fr: "MOB, incendie, voie d'eau.",
    context_en: "MOB, fire, water ingress.",
    category: "securite"
  },
  {
    id: "flu-sec-vigie",
    question_fr: "Rôle de la vigie ?",
    question_en: "Lookout's role?",
    answer_fr: "Surveiller 360°, alerter le barreur",
    answer_en: "360° watch, alert helm",
    context_fr: "Souvent à l'avant.",
    context_en: "Often at bow.",
    category: "securite"
  },
  {
    id: "flu-sec-approche-quai",
    question_fr: "Approche d'un quai ?",
    question_en: "Approaching dock?",
    answer_fr: "Lentement, contre vent/courant",
    answer_en: "Slowly, against wind/current",
    context_fr: "Maîtrise.",
    context_en: "Control.",
    category: "securite"
  },
  {
    id: "flu-sec-largage",
    question_fr: "Largage des amarres ?",
    question_en: "Casting off?",
    answer_fr: "Larguer dans l'ordre, vigie pour défenses",
    answer_en: "Cast off in order, watch fenders",
    context_fr: "Synchronisation.",
    context_en: "Synchronization.",
    category: "securite"
  },
  {
    id: "flu-sec-homme-eau-froide",
    question_fr: "Eau froide — gestes ?",
    question_en: "Cold water — actions?",
    answer_fr: "HELP position (jambes pliées)",
    answer_en: "HELP position (legs tucked)",
    context_fr: "Conserve chaleur.",
    context_en: "Preserves heat.",
    category: "securite"
  },
  {
    id: "flu-sec-formation-mob",
    question_fr: "Exercice MOB ?",
    question_en: "MOB drill?",
    answer_fr: "À pratiquer 1x par saison",
    answer_en: "Practice once per season",
    context_fr: "Avec bouée flottante.",
    context_en: "With floating buoy.",
    category: "securite"
  },
  {
    id: "flu-sec-siege",
    question_fr: "Position barreur ?",
    question_en: "Helm position?",
    answer_fr: "Vue dégagée 360°, accès commandes",
    answer_en: "Clear 360° view, controls reach",
    context_fr: "Sécurité.",
    context_en: "Safety.",
    category: "securite"
  },
  {
    id: "flu-sec-survie",
    question_fr: "Couverture survie ?",
    question_en: "Emergency blanket?",
    answer_fr: "Aluminium, recommandé à bord",
    answer_en: "Foil type, recommended",
    context_fr: "Léger.",
    context_en: "Light.",
    category: "securite"
  },
  {
    id: "flu-sec-alarmes",
    question_fr: "Alarmes moteur ?",
    question_en: "Engine alarms?",
    answer_fr: "Vérifier avant départ",
    answer_en: "Check before leaving",
    context_fr: "Témoins T° / huile.",
    context_en: "Temp / oil lights.",
    category: "securite"
  },
  {
    id: "flu-voc-vocab-poussage",
    question_fr: "Le poussage ?",
    question_en: "Pushing?",
    answer_fr: "Technique avec barges devant un pousseur",
    answer_en: "Barges in front of pusher",
    context_fr: "Très efficace.",
    context_en: "Very efficient.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-remorquage",
    question_fr: "Le remorquage ?",
    question_en: "Towing?",
    answer_fr: "Tirer un bateau à l'aide d'un remorqueur",
    answer_en: "Pulling boat with tug",
    context_fr: "Câble.",
    context_en: "Cable.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-aval-canal",
    question_fr: "Sens d'un canal sans courant ?",
    question_en: "Direction on currentless canal?",
    answer_fr: "Défini par le sens conventionnel marqué (PK croissant)",
    answer_en: "Defined by marked direction (rising PK)",
    context_fr: "Convention VNF.",
    context_en: "VNF convention.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-pk",
    question_fr: "Que veut dire PK ?",
    question_en: "What is PK?",
    answer_fr: "Point Kilométrique",
    answer_en: "Kilometric point",
    context_fr: "Repérage VNF.",
    context_en: "VNF reference.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-bief-court",
    question_fr: "Bief court ?",
    question_en: "Short reach?",
    answer_fr: "Section très courte entre 2 écluses rapprochées",
    answer_en: "Very short section between locks",
    context_fr: "Échelles d'écluses.",
    context_en: "Lock staircases.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-echelle-ecluse",
    question_fr: "Échelle d'écluses ?",
    question_en: "Lock staircase?",
    answer_fr: "Plusieurs écluses se suivant directement",
    answer_en: "Several locks back-to-back",
    context_fr: "Fonchâtel, Béziers.",
    context_en: "Fonserannes, Beziers.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-pertuis",
    question_fr: "Pertuis ?",
    question_en: "Pertuis (gate)?",
    answer_fr: "Ancien dispositif d'éclusage à porte unique",
    answer_en: "Old single-gate lock",
    context_fr: "Historique.",
    context_en: "Historic.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-musoir",
    question_fr: "Musoir ?",
    question_en: "Lock head?",
    answer_fr: "Pointe à l'entrée d'une écluse ou jetée",
    answer_en: "Tip of lock/pier",
    context_fr: "Attention manœuvres.",
    context_en: "Watch manoeuvres.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-darse",
    question_fr: "Darse ?",
    question_en: "Dock basin?",
    answer_fr: "Bassin portuaire intérieur",
    answer_en: "Inner harbor basin",
    context_fr: "Stationnement.",
    context_en: "Berthing.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-halte",
    question_fr: "Halte nautique ?",
    question_en: "Nautical halt?",
    answer_fr: "Petit ponton public pour escale",
    answer_en: "Small public dock for stops",
    context_fr: "Souvent gratuit ≤ 24h.",
    context_en: "Often free ≤24h.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-port-plaisance",
    question_fr: "Port de plaisance ?",
    question_en: "Marina?",
    answer_fr: "Port équipé pour la plaisance",
    answer_en: "Marina equipped for pleasure",
    context_fr: "Eau, électricité, sanitaires.",
    context_en: "Water, power, sanitary.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-eclusage-groupe",
    question_fr: "Éclusage groupé ?",
    question_en: "Grouped lockage?",
    answer_fr: "Plusieurs bateaux ensemble pour économiser l'eau",
    answer_en: "Several boats together to save water",
    context_fr: "Demandé par VNF.",
    context_en: "Requested by VNF.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-vannage",
    question_fr: "Vannage ?",
    question_en: "Sluicing?",
    answer_fr: "Réglage du débit par les vannes",
    answer_en: "Flow control via gates",
    context_fr: "Régule niveau.",
    context_en: "Level control.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-deversoir",
    question_fr: "Déversoir ?",
    question_en: "Overflow weir?",
    answer_fr: "Évacuation du trop-plein",
    answer_en: "Excess water release",
    context_fr: "Danger aval.",
    context_en: "Danger downstream.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-écluse-fuyante",
    question_fr: "Écluse fuyante ?",
    question_en: "Leaky lock?",
    answer_fr: "Sas qui perd de l'eau (porte non étanche)",
    answer_en: "Chamber losing water",
    context_fr: "Signaler éclusier.",
    context_en: "Inform keeper.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-cale",
    question_fr: "Cale sèche ?",
    question_en: "Dry dock?",
    answer_fr: "Bassin vidé pour réparation",
    answer_en: "Drained basin for repair",
    context_fr: "Carénage.",
    context_en: "Hull work.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-grue",
    question_fr: "Grue de mise à l'eau ?",
    question_en: "Boat crane?",
    answer_fr: "Lève les bateaux pour mise à l'eau",
    answer_en: "Lifts boats for launching",
    context_fr: "Port.",
    context_en: "Marina.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-carenage",
    question_fr: "Aire de carénage ?",
    question_en: "Careening area?",
    answer_fr: "Zone pour nettoyer la coque (recyclage eaux)",
    answer_en: "Hull cleaning area (water recycling)",
    context_fr: "Obligatoire.",
    context_en: "Mandatory.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-radoub",
    question_fr: "Cale de radoub ?",
    question_en: "Repair slip?",
    answer_fr: "Cale en pente pour réparations",
    answer_en: "Sloped slip for repairs",
    context_fr: "Petits chantiers.",
    context_en: "Small yards.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-pousseur",
    question_fr: "Pousseur ?",
    question_en: "Pusher?",
    answer_fr: "Bateau spécialisé pour pousser barges",
    answer_en: "Boat specialized in pushing barges",
    context_fr: "Puissant.",
    context_en: "Powerful.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-péniche",
    question_fr: "Péniche Freycinet ?",
    question_en: "Freycinet barge?",
    answer_fr: "38,5 m, 250 à 350 t",
    answer_en: "38.5 m, 250–350 t",
    context_fr: "Standard 19e siècle.",
    context_en: "19th c. standard.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-spits",
    question_fr: "Spits / Campinois ?",
    question_en: "Spits barge?",
    answer_fr: "Petite péniche belge",
    answer_en: "Small Belgian barge",
    context_fr: "Réseau wallon.",
    context_en: "Walloon network.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-bateliers",
    question_fr: "Batellerie ?",
    question_en: "Bargee community?",
    answer_fr: "Profession des mariniers fluviaux",
    answer_en: "River barge community",
    context_fr: "Tradition.",
    context_en: "Tradition.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-marin-eau-douce",
    question_fr: "Marinier d'eau douce ?",
    question_en: "Inland mariner?",
    answer_fr: "Conducteur professionnel fluvial",
    answer_en: "Professional inland skipper",
    context_fr: "Certifié.",
    context_en: "Certified.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-anim-saison",
    question_fr: "Saison fluviale ?",
    question_en: "River season?",
    answer_fr: "Mi-mars à fin octobre généralement",
    answer_en: "Mid-March to late October",
    context_fr: "Hors gel.",
    context_en: "Outside freeze.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-hivernage",
    question_fr: "Hivernage fluvial ?",
    question_en: "River winterizing?",
    answer_fr: "Vider eaux, antigel, rangement",
    answer_en: "Drain water, antifreeze, storage",
    context_fr: "Hors saison.",
    context_en: "Off season.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-tirant-air",
    question_fr: "Tirant d'air typique ponts ?",
    question_en: "Typical bridge clearance?",
    answer_fr: "3,40 à 5,25 m sur réseau Freycinet",
    answer_en: "3.40 to 5.25 m on Freycinet network",
    context_fr: "Mesurer son mât.",
    context_en: "Measure mast.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-niveau-eau",
    question_fr: "Lecture niveau d'eau ?",
    question_en: "Reading water level?",
    answer_fr: "Échelle limnimétrique en m",
    answer_en: "Limnimetric scale in m",
    context_fr: "Sur ouvrages.",
    context_en: "On structures.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-flot",
    question_fr: "Flot ?",
    question_en: "Floodflow?",
    answer_fr: "Eau supplémentaire en crue",
    answer_en: "Extra water in flood",
    context_fr: "Surveiller.",
    context_en: "Monitor.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-fond",
    question_fr: "Fond / hauts-fonds ?",
    question_en: "Bottom / shallows?",
    answer_fr: "Zones peu profondes",
    answer_en: "Shallow areas",
    context_fr: "Risque échouement.",
    context_en: "Grounding risk.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-meandre",
    question_fr: "Méandre ?",
    question_en: "Meander?",
    answer_fr: "Boucle naturelle d'une rivière",
    answer_en: "Natural river loop",
    context_fr: "Courant varié.",
    context_en: "Varied current.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-confluent",
    question_fr: "Confluent ?",
    question_en: "Confluence?",
    answer_fr: "Rencontre de 2 cours d'eau",
    answer_en: "Meeting of 2 streams",
    context_fr: "Vigilance.",
    context_en: "Vigilance.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-source",
    question_fr: "Source ?",
    question_en: "Source?",
    answer_fr: "Point de naissance d'un fleuve",
    answer_en: "Birth point of river",
    context_fr: "Amont absolu.",
    context_en: "Absolute upstream.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-embouchure",
    question_fr: "Embouchure ?",
    question_en: "River mouth?",
    answer_fr: "Fin du fleuve à la mer",
    answer_en: "End of river at sea",
    context_fr: "Aval absolu.",
    context_en: "Absolute downstream.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-estuaire",
    question_fr: "Estuaire ?",
    question_en: "Estuary?",
    answer_fr: "Embouchure soumise aux marées",
    answer_en: "Tidal mouth",
    context_fr: "Sel + eau douce.",
    context_en: "Salt + fresh water.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-marée-fluvial",
    question_fr: "Marée fluviale ?",
    question_en: "Tidal bore?",
    answer_fr: "Crue/décrue sur fleuves côtiers",
    answer_en: "River tide on coastal streams",
    context_fr: "Seine, Loire.",
    context_en: "Seine, Loire.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-mascaret",
    question_fr: "Mascaret ?",
    question_en: "Tidal bore wave?",
    answer_fr: "Vague de marée remontant un fleuve",
    answer_en: "Tidal wave going upstream",
    context_fr: "Dordogne, Garonne.",
    context_en: "Dordogne, Garonne.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-courbe-niveau",
    question_fr: "Crue de référence ?",
    question_en: "Reference flood?",
    answer_fr: "Niveau utilisé pour les plans de prévention",
    answer_en: "Level for prevention plans",
    context_fr: "Q10/Q100.",
    context_en: "Q10/Q100.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-vnf-zones",
    question_fr: "Bassin fluvial ?",
    question_en: "River basin?",
    answer_fr: "Réseau hydrographique homogène",
    answer_en: "Homogeneous river network",
    context_fr: "Seine, Rhône, etc.",
    context_en: "Seine, Rhône, etc.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-fleuve",
    question_fr: "Fleuve ?",
    question_en: "Major river?",
    answer_fr: "Cours d'eau se jetant à la mer",
    answer_en: "Stream flowing to sea",
    context_fr: "Loire, Seine.",
    context_en: "Loire, Seine.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-riviere",
    question_fr: "Rivière ?",
    question_en: "River?",
    answer_fr: "Cours d'eau affluent d'un fleuve",
    answer_en: "Tributary of a river",
    context_fr: "Yonne, Marne.",
    context_en: "Yonne, Marne.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-cep",
    question_fr: "CEPT, ETSI ?",
    question_en: "CEPT, ETSI?",
    answer_fr: "Organismes normalisant la VHF européenne",
    answer_en: "Bodies standardizing European VHF",
    context_fr: "Conformité.",
    context_en: "Compliance.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-clic",
    question_fr: "Clic-clac ?",
    question_en: "Clic-clac latch?",
    answer_fr: "Mécanique de fermeture de portes d'écluse",
    answer_en: "Lock gate latch",
    context_fr: "Petites écluses.",
    context_en: "Small locks.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-balise",
    question_fr: "Balise cardinale en fluvial ?",
    question_en: "Cardinal mark on rivers?",
    answer_fr: "Rare — surtout aux confluents",
    answer_en: "Rare — mainly at confluences",
    context_fr: "Standard IALA.",
    context_en: "IALA standard.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-iala",
    question_fr: "Région IALA en France ?",
    question_en: "IALA region in France?",
    answer_fr: "Région A",
    answer_en: "Region A",
    context_fr: "Rouge à bâbord (mer).",
    context_en: "Red to port (sea).",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-bord-rive",
    question_fr: "Conventions rive droite/gauche ?",
    question_en: "Right/left bank conventions?",
    answer_fr: "Toujours définies dans le sens de l'eau qui descend",
    answer_en: "Always defined going downstream",
    context_fr: "Standard.",
    context_en: "Standard.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-mer-vs-fluv",
    question_fr: "Différence mer / fluvial ?",
    question_en: "Sea vs river difference?",
    answer_fr: "Règlements distincts (RIPAM / RPNR)",
    answer_en: "Distinct regulations (COLREGS / RPNR)",
    context_fr: "Permis aussi.",
    context_en: "Licenses too.",
    category: "reglementation"
  },
  {
    id: "flu-voc-vocab-bach",
    question_fr: "Bachi-bouzouk ?",
    question_en: "Captain Haddock's insult?",
    answer_fr: "Référence culturelle — pas réglementaire",
    answer_en: "Cultural reference — not regulation",
    context_fr: "Pour rire.",
    context_en: "For fun.",
    category: "reglementation"
  },
  {
    id: "flu-mem-vhf-mayday",
    question_fr: "Que signale MAYDAY en VHF ?",
    question_en: "What does MAYDAY signal on VHF?",
    answer_fr: "Détresse — danger grave et imminent",
    answer_en: "Distress — grave and imminent danger",
    context_fr: "Ex. homme à la mer, chavirage. (Mémento Pocket)",
    context_en: "Ex. MOB, capsizing. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-vhf-panpan",
    question_fr: "Que signale PAN PAN ?",
    question_en: "What does PAN PAN signal?",
    answer_fr: "Urgence — sécurité du navire ou d'une personne",
    answer_en: "Urgency — safety of vessel or person",
    context_fr: "Ex. blessé, remorquage. (Mémento Pocket)",
    context_en: "Ex. injury, towing. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-vhf-securite",
    question_fr: "Que signale SECURITE ?",
    question_en: "What does SECURITE signal?",
    answer_fr: "Sécurité de la navigation",
    answer_en: "Navigation safety",
    context_fr: "Ex. météo, épaves. (Mémento Pocket)",
    context_en: "Ex. weather, wrecks. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-vhf-canal10",
    question_fr: "Canal VHF détresse/urgence/sécurité en fluvial ?",
    question_en: "Distress/urgency/safety VHF channel inland?",
    answer_fr: "Canal 10",
    answer_en: "Channel 10",
    context_fr: "Source : Mémento Pocket. (Mémento Pocket)",
    context_en: "Source: Pocket Memento. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-vhf-navire",
    question_fr: "Canaux navire-navire en fluvial ?",
    question_en: "Ship-to-ship VHF channels inland?",
    answer_fr: "6, 8, 13, 72 et 77",
    answer_en: "6, 8, 13, 72 and 77",
    context_fr: "Conversation entre bateaux. (Mémento Pocket)",
    context_en: "Vessel-to-vessel chat. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-vhf-atis",
    question_fr: "Que signifie ATIS ?",
    question_en: "What is ATIS?",
    answer_fr: "Automatic Transmitter Identification System",
    answer_en: "Automatic Transmitter Identification System",
    context_fr: "Identifie automatiquement l'émetteur. (Mémento Pocket)",
    context_en: "Auto-IDs the transmitter. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-vhf-mid",
    question_fr: "Que signifie MID ?",
    question_en: "What is MID?",
    answer_fr: "Maritime Identification Digit — nationalité du bateau",
    answer_en: "Maritime Identification Digit — vessel nationality",
    context_fr: "Inclus dans ATIS. (Mémento Pocket)",
    context_en: "Included in ATIS. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-vhf-anfr",
    question_fr: "Que signifie ANFR ?",
    question_en: "What is ANFR?",
    answer_fr: "Agence Nationale des Fréquences",
    answer_en: "National Frequencies Agency",
    context_fr: "Délivre les licences radio. (Mémento Pocket)",
    context_en: "Issues radio licences. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-vhf-crr-etranger",
    question_fr: "Quand le CRR est-il obligatoire ?",
    question_en: "When is CRR mandatory?",
    answer_fr: "Pour naviguer à l'étranger avec VHF",
    answer_en: "To use VHF abroad",
    context_fr: "Sinon ATIS suffit en France. (Mémento Pocket)",
    context_en: "Else ATIS suffices in France. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-vhf-appel",
    question_fr: "Ordre d'appel MAYDAY en VHF ?",
    question_en: "Order of a MAYDAY call?",
    answer_fr: "MAYDAY x3, ICI, nom du bateau x3 + indicatif",
    answer_en: "MAYDAY x3, THIS IS, vessel name x3 + callsign",
    context_fr: "Format officiel. (Mémento Pocket)",
    context_en: "Official format. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-vhf-message",
    question_fr: "Contenu d'un message de détresse ?",
    question_en: "Distress message content?",
    answer_fr: "MAYDAY, nom, position (PK), nature détresse, assistance, nb personnes",
    answer_en: "MAYDAY, name, position (PK), nature, assistance, persons",
    context_fr: "Mémoriser l'ordre. (Mémento Pocket)",
    context_en: "Memorize order. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-hierarchie",
    question_fr: "Hiérarchie des bateaux en fluvial ?",
    question_en: "Vessel hierarchy on rivers/canals?",
    answer_fr: "Professionnels > voile > rames > moteur (du + au − privilégié)",
    answer_en: "Pro > sail > rowing > motor (most to least privileged)",
    context_fr: "Source Mémento. (Mémento Pocket)",
    context_en: "Memento source. (Pocket Memento)",
    category: "navigation"
  },
  {
    id: "flu-mem-lacs",
    question_fr: "Quel règlement sur les lacs ?",
    question_en: "Which rules on lakes?",
    answer_fr: "Règles de barre et de route du domaine maritime (RIPAM)",
    answer_en: "Maritime steering/sailing rules (COLREGS)",
    context_fr: "Pas le RPNR fluvial. (Mémento Pocket)",
    context_en: "Not inland RPNR. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-croisement-classique",
    question_fr: "Règle de croisement classique fluvial ?",
    question_en: "Standard crossing rule on rivers?",
    answer_fr: "Bâbord sur bâbord — chacun tient sa droite",
    answer_en: "Port-to-port — each keeps right",
    context_fr: "Comme la route. (Mémento Pocket)",
    context_en: "Like roads. (Pocket Memento)",
    category: "navigation"
  },
  {
    id: "flu-mem-panneau-bleu",
    question_fr: "Règle du panneau bleu ?",
    question_en: "Blue panel rule?",
    answer_fr: "Le montant qui laisse l'avalant à tribord montre un panneau bleu (jour) + scintillant blanc (nuit)",
    answer_en: "Upstream vessel leaving downstream to starboard shows blue panel by day + flashing white by night",
    context_fr: "L'avalant répond du même signal. (Mémento Pocket)",
    context_en: "Downstream answers same. (Pocket Memento)",
    category: "signalisation"
  },
  {
    id: "flu-mem-feu-mat",
    question_fr: "Secteur du feu de tête de mât ?",
    question_en: "Masthead light sector?",
    answer_fr: "225° — blanc",
    answer_en: "225° — white",
    context_fr: "Bateau moteur. (Mémento Pocket)",
    context_en: "Motor vessel. (Pocket Memento)",
    category: "signalisation"
  },
  {
    id: "flu-mem-feux-cotes",
    question_fr: "Secteur des feux de côté ?",
    question_en: "Side lights sector?",
    answer_fr: "112,5° — rouge (bâbord) + vert (tribord)",
    answer_en: "112.5° — red (port) + green (starboard)",
    context_fr: "Standard CEVNI. (Mémento Pocket)",
    context_en: "CEVNI standard. (Pocket Memento)",
    category: "signalisation"
  },
  {
    id: "flu-mem-feu-poupe",
    question_fr: "Secteur du feu de poupe ?",
    question_en: "Stern light sector?",
    answer_fr: "135° — blanc",
    answer_en: "135° — white",
    context_fr: "Visible de l'arrière. (Mémento Pocket)",
    context_en: "Visible from astern. (Pocket Memento)",
    category: "signalisation"
  },
  {
    id: "flu-mem-feu-110m",
    question_fr: "Bateau > 110 m : feu supplémentaire ?",
    question_en: "Vessel > 110 m: extra light?",
    answer_fr: "Second feu de tête de mât (225°)",
    answer_en: "Second masthead light (225°)",
    context_fr: "Indique la grande longueur. (Mémento Pocket)",
    context_en: "Shows long length. (Pocket Memento)",
    category: "signalisation"
  },
  {
    id: "flu-mem-remorqueur",
    question_fr: "Feu particulier d'un remorqueur ?",
    question_en: "Tug's special light?",
    answer_fr: "Feu de poupe jaune",
    answer_en: "Yellow stern light",
    context_fr: "Identifie le remorqueur. (Mémento Pocket)",
    context_en: "Identifies the tug. (Pocket Memento)",
    category: "signalisation"
  },
  {
    id: "flu-mem-zone-abritee",
    question_fr: "Matériel zone abritée ?",
    question_en: "Sheltered zone equipment?",
    answer_fr: "1 gilet/pers, écope, amarrage, extincteur",
    answer_en: "1 jacket/person, bailer, mooring, extinguisher",
    context_fr: "Liste mémento. (Mémento Pocket)",
    context_en: "Memento list. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-zone-exposee",
    question_fr: "Matériel zone exposée (en plus) ?",
    question_en: "Exposed zone (extra) equipment?",
    answer_fr: "Ligne de mouillage + ancre, lampe étanche",
    answer_en: "Anchor + line, waterproof torch",
    context_fr: "S'ajoute à l'abritée. (Mémento Pocket)",
    context_en: "Added to sheltered. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-leman",
    question_fr: "Matériel spécifique Lac Léman ?",
    question_en: "Lake Geneva specific kit?",
    answer_fr: "Signal sonore, 3 feux rouges, compas, carte (au-delà de 3700 m)",
    answer_en: "Sound signal, 3 red flares, compass, chart (beyond 3700 m)",
    context_fr: "Particularité lacustre. (Mémento Pocket)",
    context_en: "Lake specific. (Pocket Memento)",
    category: "securite"
  },
  {
    id: "flu-mem-ancre-dangereuse",
    question_fr: "Filets / ancres dangereuses signalés par ?",
    question_en: "Dangerous nets/anchors marked by?",
    answer_fr: "1 réflecteur radar sur flotteur au-dessus de l'ancre",
    answer_en: "Radar reflector on float above anchor",
    context_fr: "Visibilité radar. (Mémento Pocket)",
    context_en: "Radar visibility. (Pocket Memento)",
    category: "signalisation"
  },
  {
    id: "flu-mem-interdit-amarre",
    question_fr: "Interdictions d'amarrage ?",
    question_en: "Mooring prohibitions?",
    answer_fr: "Aux arbres, poteaux, échelles",
    answer_en: "To trees, posts, ladders",
    context_fr: "Et jamais entraver la navigation. (Mémento Pocket)",
    context_en: "Never obstruct navigation. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-chomage",
    question_fr: "Que signifie « chômage » en fluvial ?",
    question_en: "What is 'chômage' on waterways?",
    answer_fr: "Arrêt de la navigation pour travaux",
    answer_en: "Navigation stop for works",
    context_fr: "Calendrier VNF annuel. (Mémento Pocket)",
    context_en: "Annual VNF schedule. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-rgp",
    question_fr: "Quel règlement est obligatoirement à bord ?",
    question_en: "Which regulation must be onboard?",
    answer_fr: "Le RGP (Règlement Général de Police)",
    answer_en: "RGP (General Police Regulations)",
    context_fr: "Avec RPP consultés. (Mémento Pocket)",
    context_en: "With RPP reviewed. (Pocket Memento)",
    category: "reglementation"
  },
  {
    id: "flu-mem-min-docs",
    question_fr: "Documents minimum à bord ?",
    question_en: "Minimum documents onboard?",
    answer_fr: "Permis (ou carte plaisance si nolisage) + titre de navigation",
    answer_en: "License (or charter card) + boat registration",
    context_fr: "Sinon amende. (Mémento Pocket)",
    context_en: "Otherwise fined. (Pocket Memento)",
    category: "reglementation"
  },
];
